webpackJsonp([55],{

/***/ 116:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/logo01.ad9c636.png";

/***/ }),

/***/ 117:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _promise = __webpack_require__(43);

var _promise2 = _interopRequireDefault(_promise);

var _regenerator = __webpack_require__(151);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(150);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _classCallCheck2 = __webpack_require__(209);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(210);

var _createClass3 = _interopRequireDefault(_createClass2);

var _vue = __webpack_require__(4);

var _vue2 = _interopRequireDefault(_vue);

var _util = __webpack_require__(136);

var _util2 = _interopRequireDefault(_util);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var vm = new _vue2.default();

exports.default = {
    install: function install(Vue) {
        Vue.prototype.insuranceCompanyCheck = function (dataForm) {
            return new Checker().check(dataForm);
        };
    }
};

var Checker = function () {
    function Checker() {
        (0, _classCallCheck3.default)(this, Checker);
    }

    (0, _createClass3.default)(Checker, [{
        key: "specifyObjectAttributeNullCheck",
        value: function specifyObjectAttributeNullCheck(object, attribute, errorMessage) {
            if (object[attribute] === "" || object[attribute] == null) {
                this.showMessage(errorMessage, "error");
                return false;
            }

            return true;
        }
    }, {
        key: "showMessage",
        value: function showMessage(message, type) {
            setTimeout(function () {
                vm["$message"]({
                    type: type,
                    message: message
                });
            }, 0);
        }
    }, {
        key: "insuranceCompanyListNullCheck",
        value: function insuranceCompanyListNullCheck(object) {
            var result = true;

            result &= this.specifyObjectAttributeNullCheck(object, "insuranceCompany", "保险公司不能为空");
            if (!result) return false;
            result &= this.specifyObjectAttributeNullCheck(object, "underwriteRate", "承保比例不能为空");

            result &= this.specifyObjectAttributeNullCheck(object, "premium", "保险公司保费不能为空");

            result &= this.specifyObjectAttributeNullCheck(object, "yongjinRate", "佣金比例不能为空");

            return result;
        }
    }, {
        key: "insuranceCompanyPremiumDetailListNullCheck",
        value: function insuranceCompanyPremiumDetailListNullCheck(object, companyName) {
            var result = true;

            result &= this.specifyObjectAttributeNullCheck(object, "paymentState", companyName + "的保费支付情况不能为空");

            result &= this.specifyObjectAttributeNullCheck(object, "billingState", companyName + "的保费开票状况不能为空");

            result &= this.specifyObjectAttributeNullCheck(object, "premiumDueDate", companyName + "的分期支付日期不能为空");

            result &= this.specifyObjectAttributeNullCheck(object, "paymentBal", companyName + "的分期支付金额不能为空");

            return result;
        }
    }, {
        key: "confirmWait",
        value: function () {
            var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee(message) {
                return _regenerator2.default.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                return _context.abrupt("return", vm["$confirm"](message, "提示", {
                                    confirmButtonText: "确定",
                                    cancelButtonText: "取消",
                                    type: "warning",
                                    distinguishCancelAndClose: true,
                                    closeOnClickModal: false
                                }).then(function () {
                                    return true;
                                }).catch(function (e) {
                                    if (e === "cancel" || e === "close") {
                                        return false;
                                    }
                                }));

                            case 1:
                            case "end":
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function confirmWait(_x) {
                return _ref.apply(this, arguments);
            }

            return confirmWait;
        }()
    }, {
        key: "check",
        value: function check(dataForm) {
            var _this = this;

            var companyList = dataForm.insuranceCompanyList;

            var startDateCheck = new _promise2.default(function (resolve, reject) {
                resolve(dataForm);
            });

            return startDateCheck.then(function (res) {
                var startDate = new Date(dataForm.startDate);
                var sysDate = new Date();
                if (startDate < sysDate && startDate.getDate() !== sysDate.getDate()) {
                    return vm["$confirm"]("【起保日期】早于【当前日期】是否继续？", "提示", {
                        confirmButtonText: "继续",
                        cancelButtonText: "返回",
                        type: "warning",
                        distinguishCancelAndClose: true,
                        closeOnClickModal: false
                    }).then(function () {
                        return true;
                    }).catch(function (e) {
                        if (e === "cancel" || e === "close") {
                            return _promise2.default.reject();
                        }
                    });
                }
            }).then(function () {
                var totalPremiumSum = 0,
                    underwriteRateSUm = 0,
                    selectedCompanyNameHash = {};
                for (var i = 0; i < companyList.length; i++) {
                    var companyElement = companyList[i];

                    if (!_this.insuranceCompanyListNullCheck(companyElement)) return _promise2.default.reject();

                    if (selectedCompanyNameHash[companyElement.insuranceCompany] === companyElement.insuranceCompany) {
                        _this.showMessage("【" + companyElement.insuranceCompany + "】保险公司存在重复，请重新选择", "error");
                        return _promise2.default.reject();
                    }

                    selectedCompanyNameHash[companyElement.insuranceCompany] = companyElement.insuranceCompany;

                    var paymentBalSum = 0,
                        premiumDetailList = companyElement.premiumDetailList;
                    for (var j = 0; j < premiumDetailList.length; j++) {
                        var premiumDetailEle = premiumDetailList[j];

                        if (!_this.insuranceCompanyPremiumDetailListNullCheck(premiumDetailEle, companyElement.insuranceCompany)) return _promise2.default.reject();

                        var t = _util2.default.Delcommafy(premiumDetailEle.paymentBal);
                        t *= 100;
                        paymentBalSum += t;
                    }

                    paymentBalSum = paymentBalSum / 100;
                    paymentBalSum = paymentBalSum.toFixed(2);

                    if (_util2.default.Delcommafy(companyElement.premium) - paymentBalSum !== 0) {
                        _this.showMessage(companyElement.insuranceCompany + "的分期保费之和不等于总计保费", "error");
                        return _promise2.default.reject();
                    }

                    totalPremiumSum += _util2.default.Delcommafy(companyElement.premium) * 100;
                    var num = companyElement.underwriteRate.replace(/%/g, "");
                    underwriteRateSUm += Number(num);
                }

                totalPremiumSum = totalPremiumSum / 100;
                totalPremiumSum = totalPremiumSum.toFixed(2);

                if (_util2.default.Delcommafy(dataForm.totalPremium) - totalPremiumSum !== 0) {
                    _this.showMessage("公司的保费之和不等于总保费", "error");
                    return _promise2.default.reject();
                }

                if (underwriteRateSUm / 100 - 1 !== 0) {
                    _this.showMessage("承保比例之和需要等于100%", "error");
                    return _promise2.default.reject();
                }
            }).then(function () {
                for (var i = 0; i < companyList.length; i++) {
                    for (var j = 0; j < companyList[i].premiumDetailList.length; j++) {
                        var premiumDetailEle = companyList[i].premiumDetailList[j];
                        if (premiumDetailEle.paymentState === "1" && (premiumDetailEle.actualPaymentDate === "" || premiumDetailEle.actualPaymentDate == null)) {
                            _this.showMessage(companyList[i].insuranceCompany + "，保费支付情况为【已支付】，需填写对应【保费实收日期】", "error");
                            return _promise2.default.reject();
                        }
                    }
                }
            }).then(function () {
                var ifConfirm = false;
                for (var i = 0; i < companyList.length; i++) {
                    var companyElement = companyList[i];
                    var premiumDetailList = companyElement.premiumDetailList;

                    for (var j = 0; j < premiumDetailList.length; j++) {
                        var premiumDetailEle = premiumDetailList[j];

                        var start = new Date(dataForm.startDate);
                        var end = new Date(dataForm.endDate);
                        var cur = new Date(premiumDetailEle.premiumDueDate);

                        if (j !== 0) {
                            start = new Date(premiumDetailList[j - 1].premiumDueDate);
                        }

                        if (cur < start || cur > end) {
                            ifConfirm = true;
                        }
                    }
                }

                if (ifConfirm) {
                    return _this.confirmWait("存在保险公司【分期支付日期】不符合【分期支付日期】必须在保单【起保日期】和【终止日期】之间，且每期递增的规则！是否继续？");
                } else {
                    return true;
                }
            }).catch(function (error) {
                return _promise2.default.resolve(false);
            });
        }
    }]);
    return Checker;
}();

/***/ }),

/***/ 118:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _vue = __webpack_require__(4);

var _vue2 = _interopRequireDefault(_vue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.directive('dialogDrag', {
  bind: function bind(el, binding, vnode, oldVnode) {
    var dialogHeaderEl = el.querySelector('.el-dialog__header');
    var dragDom = el.querySelector('.el-dialog');
    dialogHeaderEl.style.cursor = 'move';

    var sty = dragDom.currentStyle || window.getComputedStyle(dragDom, null);
    dialogHeaderEl.onmousedown = function (e) {
      var disX = e.clientX - dialogHeaderEl.offsetLeft;
      var disY = e.clientY - dialogHeaderEl.offsetTop;

      var styL = void 0,
          styT = void 0;

      if (sty.left.includes('%')) {
        styL = +document.body.clientWidth * (+sty.left.replace(/\%/g, '') / 100);
        styT = +document.body.clientHeight * (+sty.top.replace(/\%/g, '') / 100);
      } else {
        styL = +sty.left.replace(/\px/g, '');
        styT = +sty.top.replace(/\px/g, '');
      };
      document.onmousemove = function (e) {
        var l = e.clientX - disX;
        var t = e.clientY - disY;

        dragDom.style.left = l + styL + 'px';
        dragDom.style.top = t + styT + 'px';
      };
      document.onmouseup = function (e) {
        document.onmousemove = null;
        document.onmouseup = null;
      };
    };
  }
});

_vue2.default.directive('dialogDragWidth', {
  bind: function bind(el, binding, vnode, oldVnode) {
    var dragDom = binding.value.$el.querySelector('.el-dialog');
    el.onmousedown = function (e) {
      var disX = e.clientX - el.offsetLeft;
      document.onmousemove = function (e) {
        e.preventDefault();
        var l = e.clientX - disX;
        dragDom.style.width = l + 'px';
      };
      document.onmouseup = function (e) {
        document.onmousemove = null;
        document.onmouseup = null;
      };
    };
  }
});

/***/ }),

/***/ 119:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _Login = __webpack_require__(379);

var _Login2 = _interopRequireDefault(_Login);

var _LoginForm = __webpack_require__(375);

var _LoginForm2 = _interopRequireDefault(_LoginForm);

var _ = __webpack_require__(377);

var _2 = _interopRequireDefault(_);

var _Home = __webpack_require__(378);

var _Home2 = _interopRequireDefault(_Home);

var _changpwd = __webpack_require__(380);

var _changpwd2 = _interopRequireDefault(_changpwd);

var _vueRouter = __webpack_require__(70);

var _vueRouter2 = _interopRequireDefault(_vueRouter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var originalPush = _vueRouter2.default.prototype.push;
var originalReplace = _vueRouter2.default.prototype.replace;

_vueRouter2.default.prototype.push = function push(location, onResolve, onReject) {
    return originalPush.call(this, location).catch(function (err) {
        return err;
    });
};

_vueRouter2.default.prototype.replace = function replace(location, onResolve, onReject) {
    return originalReplace.call(this, location).catch(function (err) {
        return err;
    });
};


var routes = [{
    path: '/',
    component: _LoginForm2.default,
    redirect: '/loginForm',
    name: '',
    hidden: true
}, {
    path: '/changpwd',
    component: _changpwd2.default,
    name: '',
    hidden: true
}, {
    path: '/loginForm',
    component: _LoginForm2.default,
    name: '',
    hidden: true
}, {
    path: '/404',
    component: _2.default,
    name: '',
    hidden: true
}, {
    path: '/home',
    component: _Home2.default,
    redirect: '/index',
    name: '首页',
    iconCls: 'el-icon-message',
    children: [{ path: '/index', component: function component(resolve) {
            return __webpack_require__.e/* require */(10).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(425)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        }, name: '首页' }]
}, {
    path: '/home',
    component: _Home2.default,
    name: '理赔管理',
    iconCls: 'fa fa-bar-chart',
    children: [{
        path: '/claimQuery',
        component: function component(resolve) {
            return __webpack_require__.e/* require */(41).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(397)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        },
        name: '理赔查询'
    }, {
        path: '/claimAdd',
        component: function component(resolve) {
            return __webpack_require__.e/* require */(11).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(396)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        },
        name: '新增案件'
    }, {
        path: '/unfinishedClaim',
        component: function component(resolve) {
            return __webpack_require__.e/* require */(29).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(400)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        },
        name: '未决案件'
    }, {
        path: '/finishedClaim',
        component: function component(resolve) {
            return __webpack_require__.e/* require */(15).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(398)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        },
        name: '已决案件'
    }, {
        path: '/returnListPage',
        component: function component(resolve) {
            return __webpack_require__.e/* require */(40).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(399)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        },
        name: '理赔回访'
    }]
}, {
    path: '/home',
    component: _Home2.default,
    name: '资料',
    iconCls: 'fa fa-bar-chart',
    children: [{
        path: '/answerManager',
        component: function component(resolve) {
            return __webpack_require__.e/* require */(39).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(403)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        },
        name: '疑问解答'
    }, {
        path: '/caseList',
        component: function component(resolve) {
            return __webpack_require__.e/* require */(33).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(404)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        },
        name: '相关案例'
    }, {
        path: '/companyStandard',
        component: function component(resolve) {
            return __webpack_require__.e/* require */(38).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(406)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        },
        name: '公司规范'
    }, {
        path: '/companyStandardTemp',
        component: function component(resolve) {
            return __webpack_require__.e/* require */(37).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(407)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        },
        name: '公司规范模板'
    }, {
        path: '/personnelNotice',
        component: function component(resolve) {
            return __webpack_require__.e/* require */(36).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(408)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        },
        name: '人事通知'
    }]
}, {
    path: '/home',
    component: _Home2.default,
    name: '资料管理',
    iconCls: 'fa fa-bar-chart',
    children: [{
        path: '/problemManager',
        component: function component(resolve) {
            return __webpack_require__.e/* require */(31).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(409)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        },
        name: '问题管理'
    }, {
        path: '/caseManager',
        component: function component(resolve) {
            return __webpack_require__.e/* require */(32).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(405)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        },
        name: '案例管理'
    }, {
        path: '/companyStandardManager',
        component: function component(resolve) {
            return __webpack_require__.e/* require */(30).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(429)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        },
        name: '公司规范管理'
    }, {
        path: '/personnelNoticeManager',
        component: function component(resolve) {
            return __webpack_require__.e/* require */(35).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(430)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        },
        name: '人事通知管理'
    }]
}, {
    path: '/home',
    component: _Home2.default,
    name: '系统管理',
    iconCls: 'fa fa-bar-chart',
    children: [{
        path: '/menuManager',
        component: function component(resolve) {
            return __webpack_require__.e/* require */(25).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(428)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        },
        name: '菜单管理'
    }, {
        path: '/buttonManager',
        component: function component(resolve) {
            return __webpack_require__.e/* require */(9).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(153)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        },
        name: '按钮管理'
    }, {
        path: '/roleManager',
        component: function component(resolve) {
            return __webpack_require__.e/* require */(23).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(433)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        },
        name: '角色管理'
    }, {
        path: '/userManager',
        component: function component(resolve) {
            return __webpack_require__.e/* require */(24).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(434)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        },
        name: '系统管理-客户列表'
    }, {
        path: '/permissionManager',
        component: function component(resolve) {
            return __webpack_require__.e/* require */(22).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(432)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        },
        name: '权限管理'
    }, {
        path: '/paramManager',
        component: function component(resolve) {
            return __webpack_require__.e/* require */(26).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(431)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        },
        name: '参数管理'
    }, {
        path: '/buttonManager',
        component: function component(resolve) {
            return __webpack_require__.e/* require */(9/* duplicate */).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(153)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        },
        name: '按钮管理'
    }]
}, {
    path: '/home',
    component: _Home2.default,
    name: '保单系统管理',
    iconCls: 'fa fa-bar-chart',
    children: [{
        path: '/warrantyAdd',
        component: function component(resolve) {
            return __webpack_require__.e/* require */(7/* duplicate */).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(84)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        },
        name: '新增保单'
    }, {
        path: '/warrantySearch',
        component: function component(resolve) {
            return __webpack_require__.e/* require */(6).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(154)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        },
        name: '保单查询'
    }, {
        path: '/tempWarrantySearch',
        component: function component(resolve) {
            return __webpack_require__.e/* require */(14).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(436)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        },
        name: '暂存保单'
    }, {
        path: '/lossWarrantySearch',
        component: function component(resolve) {
            return __webpack_require__.e/* require */(13).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(437)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        },
        name: '注销保单'
    }, {
        path: '/warrantyAuditing',
        component: function component(resolve) {
            return __webpack_require__.e/* require */(44).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(438)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        },
        name: '审核保单'
    }, {
        path: '/warrantDetail',
        component: function component(resolve) {
            return __webpack_require__.e/* require */(3/* duplicate */).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(80)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        },
        name: '保单详情'
    }]
}, {
    path: '/home',
    component: _Home2.default,
    name: '询价管理',
    iconCls: 'fa fa-bar-chart',
    children: [{
        path: '/enquiryAdd',
        component: function component(resolve) {
            return __webpack_require__.e/* require */(21).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(410)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        },
        name: '添加询价'
    }, {
        path: '/enquiryListhby',
        component: function component(resolve) {
            return __webpack_require__.e/* require */(51).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(412)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        },
        name: '询价列表-承保人'
    }, {
        path: '/enquiryListhbjl',
        component: function component(resolve) {
            return __webpack_require__.e/* require */(52).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(411)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        },
        name: '询价列表-承保经理'
    }, {
        path: '/enquiryRejectList',
        component: function component(resolve) {
            return __webpack_require__.e/* require */(50).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(413)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        },
        name: '询价丢失列表'
    }]
}, {
    path: '/home',
    component: _Home2.default,
    name: '续保管理',
    iconCls: 'fa fa-bar-chart',
    children: [{
        path: '/renewalPolicyList',
        component: function component(resolve) {
            return __webpack_require__.e/* require */(27).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(427)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        },
        name: '续保清单'
    }, {
        path: '/renewalPolicyDelList',
        component: function component(resolve) {
            return __webpack_require__.e/* require */(28).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(426)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        },
        name: '续保丢失'
    }]
}, {
    path: '/home',
    component: _Home2.default,
    name: '出单管理',
    iconCls: 'fa fa-bar-chart',
    children: [{
        path: '/SingleList',
        component: function component(resolve) {
            return __webpack_require__.e/* require */(16).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(395)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        },
        name: '出单列表'
    }]
}, {
    path: '/home',
    component: _Home2.default,
    name: '财务管理',
    iconCls: 'fa fa-bar-chart',
    children: [{
        path: '/InvoiceList',
        component: function component(resolve) {
            return __webpack_require__.e/* require */(49).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(415)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        },
        name: '开票管理'
    }, {
        path: '/PaymentManager',
        component: function component(resolve) {
            return __webpack_require__.e/* require */(43).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(417)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        },
        name: '支付管理'
    }, {
        path: '/normalCollection',
        component: function component(resolve) {
            return __webpack_require__.e/* require */(19).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(420)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        },
        name: '正常保费催收管理'
    }, {
        path: '/postponeCollection',
        component: function component(resolve) {
            return __webpack_require__.e/* require */(47).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(422)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        },
        name: '延期保费催收管理'
    }, {
        path: '/warrantyMannger',
        component: function component(resolve) {
            return __webpack_require__.e/* require */(6/* duplicate */).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(154)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        },
        name: '保单管理'
    }, {
        path: '/insuranceCompany',
        component: function component(resolve) {
            return __webpack_require__.e/* require */(20).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(419)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        },
        name: '保险公司管理'
    }, {
        path: '/unpaidCollection',
        component: function component(resolve) {
            return __webpack_require__.e/* require */(17).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(424)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        },
        name: '出单保费催收'
    }, {
        path: '/insuranceCombination',
        component: function component(resolve) {
            return __webpack_require__.e/* require */(34).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(414)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        },
        name: '共保组合'
    }]
}, {
    path: '/home',
    component: _Home2.default,
    name: '国外财务管理',
    iconCls: 'fa fa-bar-chart',
    children: [{
        path: '/normalCollectionForeign',
        component: function component(resolve) {
            return __webpack_require__.e/* require */(18).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(421)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        },
        name: '正常保费催收管理-外'
    }, {
        path: '/InvoiceListForeign',
        component: function component(resolve) {
            return __webpack_require__.e/* require */(48).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(416)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        },
        name: '经纪费结算管理-外'
    }, {
        path: '/postponeCollectionForeign',
        component: function component(resolve) {
            return __webpack_require__.e/* require */(46).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(423)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        },
        name: '延期保费催收管理-外'
    }, {
        path: '/PaymentManagerForeign',
        component: function component(resolve) {
            return __webpack_require__.e/* require */(42).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(418)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        },
        name: '支付管理-外'
    }]
}, {
    path: '/home',
    component: _Home2.default,
    name: 'CRM系统',
    iconCls: 'fa fa-bar-chart',
    children: [{
        path: '/usermanngerList',
        component: function component(resolve) {
            return __webpack_require__.e/* require */(12).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(402)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        },
        name: 'CRM系统-客户列表'
    }, {
        path: '/userMangerStateList',
        component: function component(resolve) {
            return __webpack_require__.e/* require */(53).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(401)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        },
        name: 'CRM系统-客户状态'
    }, { path: '/Cooperative', component: function component(resolve) {
            return __webpack_require__.e/* require */(4/* duplicate */).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(82)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        }, name: '已合作详情' }, { path: '/noCooperation', component: function component(resolve) {
            return __webpack_require__.e/* require */(5/* duplicate */).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(83)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        }, name: '未合作详情' }]
}, {
    path: '/home',
    component: _Home2.default,
    name: '客户管理',
    iconCls: 'fa fa-bar-chart',
    children: [{
        path: '/userList',
        component: function component(resolve) {
            return __webpack_require__.e/* require */(45).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(435)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        },
        name: '客户管理-列表'
    }, {
        path: '/managerCooperative',
        component: function component(resolve) {
            return __webpack_require__.e/* require */(1/* duplicate */).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(85)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        },
        name: '客户列表-已合作详情'
    }, {
        path: '/managerNocooperative',
        component: function component(resolve) {
            return __webpack_require__.e/* require */(2/* duplicate */).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(86)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        },
        name: '客户列表-未合作详情'
    }]
}];

exports.default = routes;

/***/ }),

/***/ 120:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _vue = __webpack_require__(4);

var _vue2 = _interopRequireDefault(_vue);

var _vuex = __webpack_require__(71);

var _vuex2 = _interopRequireDefault(_vuex);

var _actions = __webpack_require__(204);

var actions = _interopRequireWildcard(_actions);

var _getters = __webpack_require__(205);

var getters = _interopRequireWildcard(_getters);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.use(_vuex2.default);

var state = {
    count: 10
};

var mutations = {
    INCREMENT: function INCREMENT(state) {
        state.count++;
    },
    DECREMENT: function DECREMENT(state) {
        state.count--;
    }
};

exports.default = new _vuex2.default.Store({
    actions: actions,
    getters: getters,
    state: state,
    mutations: mutations
});

/***/ }),

/***/ 124:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 125:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 126:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 127:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 128:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 132:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(271)

var Component = __webpack_require__(11)(
  /* script */
  __webpack_require__(194),
  /* template */
  __webpack_require__(388),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 133:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(266)

var Component = __webpack_require__(11)(
  /* script */
  __webpack_require__(197),
  /* template */
  __webpack_require__(383),
  /* scopeId */
  "data-v-292a2d02",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 136:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.cardWidthAdjust = undefined;

var _typeof2 = __webpack_require__(25);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SIGN_REGEXP = /([yMdhsm])(\1*)/g;
var DEFAULT_PATTERN = 'yyyy-MM-dd';

function padding(s, len) {
    var len = len - (s + '').length;
    for (var i = 0; i < len; i++) {
        s = '0' + s;
    }
    return s;
};

var cardWidthAdjust = exports.cardWidthAdjust = function cardWidthAdjust(_) {
    var card = document.getElementsByClassName("el-card__body");
    for (var index = 0; index < card.length; index++) {
        var wid = card[index]["offsetWidth"];
        var widInt = parseInt(parseInt(wid) / 100);

        widInt = widInt === 15 || widInt === 16 ? 14.7 : widInt;

        card[index].style.width = widInt * 100 + "px";
    }
};
exports.default = {
    showAsThousand: function showAsThousand(val) {
        if (val === null || val === "0") {
            return "0";
        }

        if (val > 1000) {
            return val.replace(/(\d{1,3})(?=(\d{3})+(?:$|\.))/g, "$1,");
        } else {
            return val;
        }
    },

    filterMultiKey: function filterMultiKey(val, list, field) {
        var copy = val.replace(/，/ig, ',');
        var key = ".*" + copy.replace(/,/ig, '\.\*') + ".*";

        var n = [];
        for (var i = 0; i < list.length; i++) {
            var pattern = new RegExp('(' + key + ')', "ig");
            if (pattern.test(list[i][field])) {
                n.push(list[i]);
            }
        }

        return n;
    },
    powerOfTwo: function powerOfTwo(n) {
        return (n &= n - 1) !== 0 ? (n + 1) / 2 : n / 2;
    },
    evalStringToArray: function evalStringToArray(resultRaw) {
        var formats = resultRaw.replace(/([！。])/g, "$1@");
        var array = formats.split(/@/);

        var a = [];
        var b = [];

        for (var i = 0; i < array.length; i++) {
            if (!array[i] || array[i] === "") continue;

            if (array[i].indexOf("。") !== -1) {
                a.push(array[i]);
            } else {
                b.push(array[i]);
            }
        }

        var lenOfA = Math.ceil(a.length / 2);
        var lenOfB = Math.ceil(b.length / 2);
        var result = new Array(lenOfA + lenOfB);

        for (var _i = 0; _i < result.length; _i++) {
            result[_i] = new Array(2);
            if (lenOfB !== 0 && _i <= lenOfB) {
                result[_i][0] = b[_i * 2];
                result[_i][1] = b[_i * 2 + 1];
            } else {
                var t = _i - lenOfB;
                result[_i][0] = a[_i * 2];
                result[_i][1] = a[_i * 2 + 1];
            }
        }
        return result;
    },

    deepCopyObj: one,
    formatDate: {
        format: function format(date, pattern) {
            pattern = pattern || DEFAULT_PATTERN;
            return pattern.replace(SIGN_REGEXP, function ($0) {
                switch ($0.charAt(0)) {
                    case 'y':
                        return padding(date.getFullYear(), $0.length);
                    case 'M':
                        return padding(date.getMonth() + 1, $0.length);
                    case 'd':
                        return padding(date.getDate(), $0.length);
                    case 'w':
                        return date.getDay() + 1;
                    case 'h':
                        return padding(date.getHours(), $0.length);
                    case 'm':
                        return padding(date.getMinutes(), $0.length);
                    case 's':
                        return padding(date.getSeconds(), $0.length);
                }
            });
        },
        parse: function parse(dateString, pattern) {
            var matchs1 = pattern.match(SIGN_REGEXP);
            var matchs2 = dateString.match(/(\d)+/g);
            if (matchs1.length == matchs2.length) {
                var _date = new Date(1970, 0, 1);
                for (var i = 0; i < matchs1.length; i++) {
                    var _int = parseInt(matchs2[i]);
                    var sign = matchs1[i];
                    switch (sign.charAt(0)) {
                        case 'y':
                            _date.setFullYear(_int);
                            break;
                        case 'M':
                            _date.setMonth(_int - 1);
                            break;
                        case 'd':
                            _date.setDate(_int);
                            break;
                        case 'h':
                            _date.setHours(_int);
                            break;
                        case 'm':
                            _date.setMinutes(_int);
                            break;
                        case 's':
                            _date.setSeconds(_int);
                            break;
                    }
                }
                return _date;
            }
            return null;
        }

    },

    IDCard: function IDCard(val) {
        var area = {
            11: "北京",
            12: "天津",
            13: "河北",
            14: "山西",
            15: "内蒙古",
            21: "辽宁",
            22: "吉林",
            23: "黑龙江",
            31: "上海",
            32: "江苏",
            33: "浙江",
            34: "安徽",
            35: "福建",
            36: "江西",
            37: "山东",
            41: "河南",
            42: "湖北",
            43: "湖南",
            44: "广东",
            45: "广西",
            46: "海南",
            50: "重庆",
            51: "四川",
            52: "贵州",
            53: "云南",
            54: "西藏",
            61: "陕西",
            62: "甘肃",
            63: "青海",
            64: "宁夏",
            65: "新疆",
            71: "台湾",
            81: "香港",
            82: "澳门",
            91: "国外"
        };
        var Y, JYM;
        var S, M;
        var idcard_array = new Array();
        idcard_array = val.split("");
        var ereg;

        if (area[parseInt(val.substr(0, 2))] == null) {
            return {
                valid: false,
                msg: "身份证号码地区非法！"
            };
        }

        switch (val.length) {
            case 15:
                if ((parseInt(val.substr(6, 2)) + 1900) % 4 == 0 || (parseInt(val.substr(6, 2)) + 1900) % 100 == 0 && (parseInt(val.substr(6, 2)) + 1900) % 4 == 0) {
                    ereg = /^[1-9][0-9]{5}[0-9]{2}((01|03|05|07|08|10|12)(0[1-9]|[1-2][0-9]|3[0-1])|(04|06|09|11)(0[1-9]|[1-2][0-9]|30)|02(0[1-9]|[1-2][0-9]))[0-9]{3}$/;
                } else {
                    ereg = /^[1-9][0-9]{5}[0-9]{2}((01|03|05|07|08|10|12)(0[1-9]|[1-2][0-9]|3[0-1])|(04|06|09|11)(0[1-9]|[1-2][0-9]|30)|02(0[1-9]|1[0-9]|2[0-8]))[0-9]{3}$/;
                }
                if (ereg.test(val)) return {
                    valid: true,
                    msg: ''
                };else {
                    return {
                        valid: false,
                        msg: "身份证号码出生日期超出范围！"
                    };
                }
                break;
            case 18:
                if (parseInt(val.substr(6, 4)) % 4 == 0 || parseInt(val.substr(6, 4)) % 100 == 0 && parseInt(val.substr(6, 4)) % 4 == 0) {
                    ereg = /^[1-9][0-9]{5}(19|2[0-9])[0-9]{2}((01|03|05|07|08|10|12)(0[1-9]|[1-2][0-9]|3[0-1])|(04|06|09|11)(0[1-9]|[1-2][0-9]|30)|02(0[1-9]|[1-2][0-9]))[0-9]{3}[0-9Xx]$/;
                } else {
                    ereg = /^[1-9][0-9]{5}(19|2[0-9])[0-9]{2}((01|03|05|07|08|10|12)(0[1-9]|[1-2][0-9]|3[0-1])|(04|06|09|11)(0[1-9]|[1-2][0-9]|30)|02(0[1-9]|1[0-9]|2[0-8]))[0-9]{3}[0-9Xx]$/;
                }
                if (ereg.test(val)) {
                    S = (parseInt(idcard_array[0]) + parseInt(idcard_array[10])) * 7 + (parseInt(idcard_array[1]) + parseInt(idcard_array[11])) * 9 + (parseInt(idcard_array[2]) + parseInt(idcard_array[12])) * 10 + (parseInt(idcard_array[3]) + parseInt(idcard_array[13])) * 5 + (parseInt(idcard_array[4]) + parseInt(idcard_array[14])) * 8 + (parseInt(idcard_array[5]) + parseInt(idcard_array[15])) * 4 + (parseInt(idcard_array[6]) + parseInt(idcard_array[16])) * 2 + parseInt(idcard_array[7]) * 1 + parseInt(idcard_array[8]) * 6 + parseInt(idcard_array[9]) * 3;
                    Y = S % 11;
                    M = "F";
                    JYM = "10X98765432";
                    M = JYM.substr(Y, 1);
                    if (M == idcard_array[17]) {
                        return {
                            valid: true,
                            msg: ''
                        };
                    } else {
                        return {
                            valid: false,
                            msg: "身份证号码末位校验出错！"
                        };
                    }
                } else {
                    return {
                        valid: false,
                        msg: "身份证号码出生日期超出范围！"
                    };
                }
                break;
            default:
                return {
                    valid: false,
                    msg: "身份证号码位数有误,应该为15位或18位！"
                };
        }
    },

    adjustOrgNo: function adjustOrgNo(val, field) {
        var Errors = new Array("组织机构代码长度小于9，请重新输入！", "请输入正确的组织机构代码！");
        var orgNo = val;
        if (orgNo.length < 9) {
            return {
                valid: false,
                msg: Errors[0]
            };
        }

        var org_str = new Array();
        var k = 0;
        while (k < orgNo.length) {
            org_str[k] = orgNo.charCodeAt(k);
            k = k + 1;
        }
        var out_org = new Array(20);
        var w_i = [3, 7, 9, 10, 5, 8, 4, 2];
        var c_i = new Array(10);
        var i,
            j,
            c,
            s = 0;
        var fir_value, sec_value;
        if (org_str[8] != 45) {
            return {
                valid: false,
                msg: Errors[1]
            };
        }
        for (i = 0; i < 10; i++) {
            c = org_str[i];
            if (c <= 122 && c >= 97) {
                return {
                    valid: false,
                    msg: Errors[1]
                };
            }
            out_org[i] = c;
        }
        fir_value = org_str[0];
        sec_value = org_str[1];
        if (fir_value >= 65 && fir_value <= 90) {
            c_i[0] = fir_value + 32 - 87;
        } else if (fir_value >= 48 && fir_value <= 57) {
            c_i[0] = fir_value - 48;
        } else {
            return {
                valid: false,
                msg: Errors[1]
            };
        }
        s += w_i[0] * c_i[0];
        if (sec_value >= 65 && sec_value <= 90) {
            c_i[1] = sec_value - 65 + 10;
        } else if (sec_value >= 48 && sec_value <= 57) {
            c_i[1] = sec_value - 48;
        } else {
            return {
                valid: false,
                msg: Errors[1]
            };
        }
        s += w_i[1] * c_i[1];
        for (j = 2; j < 8; j++) {
            if (org_str[j] < 48 || org_str[j] > 57) {
                return {
                    valid: false,
                    msg: Errors[1]
                };
            }
            c_i[j] = org_str[j] - 48;
            s += w_i[j] * c_i[j];
        }
        c = 11 - s % 11;
        out_org[9] = c + 48;
        if (c == 10) out_org[9] = 88;
        if (c == 11) out_org[9] = 48;
        if (org_str[9] == 88 && c == 10 || c == 11 && org_str[9] == 48 || c == org_str[9] - 48) {
            return {
                valid: true,
                msg: ''
            };
        } else {
            return {
                valid: false,
                msg: Errors[1]
            };
        }
    },

    uniteCreditNo: function uniteCreditNo(val, field) {
        switch (val.length) {
            case 18:
                var patrn = /^[0-9A-Z]+$/;

                if (val.length != 18 || patrn.test(val) == false) {
                    return {
                        valid: false,
                        msg: "请输入正确的统一信用代码"
                    };
                } else {
                    var Ancode;
                    var Ancodevalue;
                    var total = 0;
                    var weightedfactors = [1, 3, 9, 27, 19, 26, 16, 17, 20, 29, 25, 13, 8, 24, 10, 30, 28];
                    var str = '0123456789ABCDEFGHJKLMNPQRTUWXY';

                    for (var i = 0; i < val.length - 1; i++) {
                        Ancode = val.substring(i, i + 1);
                        Ancodevalue = str.indexOf(Ancode);
                        total = total + Ancodevalue * weightedfactors[i];
                    }
                    var logiccheckcode = 31 - total % 31;

                    if (logiccheckcode == 31) {
                        logiccheckcode = 0;
                    }
                    var Str = "0,1,2,3,4,5,6,7,8,9,A,B,C,D,E,F,G,H,J,K,L,M,N,P,Q,R,T,U,W,X,Y";
                    var Array_Str = Str.split(',');
                    logiccheckcode = Array_Str[logiccheckcode];

                    var checkcode = val.substring(17, 18);
                    if (logiccheckcode != checkcode) {
                        return {
                            valid: false,
                            msg: "请输入正确的统一信用代码"
                        };
                    } else {
                        return {
                            valid: true,
                            msg: ""
                        };
                    }
                }
            default:
                return {
                    valid: false,
                    msg: "请输入正确的统一信用代码"
                };
        }
    },

    codeXy: function codeXy(val, field) {
        var Errors = new Array("请输入正确的营业执照号码", "");
        var no = String(val);
        var reg = new RegExp("\d{15}");
        if (reg.test(no)) {
            return {
                valid: false,
                msg: Errors[0]
            };
        }
        var m, n, s, p, i;
        var value;
        var p = 10;
        var m = 10;
        var n = 11;
        for (var i = 1; i <= 14; i++) {
            value = no.substr(i - 1, 1);
            s = Number(value);
            p = p + s;
            p = p % m;
            if (p == 0) {
                p = m;
            }
            p = p * 2;
            p = p % n;
        }
        value = no.substr(14, 1);
        p = p + Number(value);
        p = p % m;
        if (p == 1) {
            return {
                valid: true,
                msg: ''
            };
        } else {
            var check = new RegExp('^\\d{6}(n|N)([a-z]|[0-9]|[A-Z]){1}\\d{6}(x|X)$');
            if (check.test(no)) {
                return {
                    valid: true,
                    msg: ''
                };
            }
            check = new RegExp('^([0-9]|[a-z]){13}$');
            if (check.test(no)) {
                return {
                    valid: true,
                    msg: ''
                };
            }
            return {
                valid: false,
                msg: Errors[0]
            };
        }
    },

    mobilePhone: function mobilePhone(val, field) {
        if (/^1[3456789]\d{9}$/.test(val)) {
            return true;
        } else {
            return false;
        }
    },

    tel: function tel(val) {
        if (/^((0\d{2,3})(-)?)(\d{7,8})(-(\d{3,}))?$/.test(val)) {
            return true;
        } else {
            return false;
        }
    },

    FormatCurrency: function FormatCurrency(num) {
        if (num != undefined) {
            num = num.toString().replace(/\$|\,/g, '');
            if (isNaN(num)) num = "0";
            var sign = num == (num = Math.abs(num));
            num = Math.floor(num * 100 + 0.50000000001);
            var cents = num % 100;
            num = Math.floor(num / 100).toString();
            if (cents < 10) cents = "0" + cents;
            for (var i = 0; i < Math.floor((num.length - (1 + i)) / 3); i++) {
                num = num.substring(0, num.length - (4 * i + 3)) + ',' + num.substring(num.length - (4 * i + 3));
            }return (sign ? '' : '-') + num + '.' + cents;
        }
    },
    Delcommafy: function Delcommafy(num) {
        if (num != undefined) {
            num = num.toString();
            num = num.replace(/[ ]/g, "");
            num = num.replace(/,/gi, '');
            return Number(num);
        }
    },
    getMenuId: function getMenuId(path) {
        var menuId = '';
        var menuList = JSON.parse(sessionStorage.getItem('menuList'));
        if (menuList && menuList.length > 0) {
            menuList.forEach(function (element) {
                if (element.children && element.children.length > 0) {
                    element.children.forEach(function (ele) {
                        if (ele.menuUrl == path) {
                            menuId = ele.menuId;
                        }
                    });
                } else {
                    if (element.menuUrl == path) {
                        menuId = ele.menuId;
                    }
                }
            });
        }
        return menuId;
    },
    getContentOfPid: function getContentOfPid(path) {
        var contentOfPid = '';
        var menuList = JSON.parse(sessionStorage.getItem('menuList'));
        if (menuList && menuList.length > 0) {
            menuList.forEach(function (element) {
                if (element.children && element.children.length > 0) {
                    element.children.forEach(function (ele) {
                        if (ele.menuUrl == path) {
                            if (ele.contentOfPid && ele.contentOfPid != "") {
                                contentOfPid = ele.contentOfPid;
                            } else {
                                contentOfPid = "";
                            }
                        }
                    });
                } else {
                    if (element.menuUrl == path) {
                        if (element.contentOfPid && element.contentOfPid != "") {
                            contentOfPid = element.contentOfPid;
                        } else {
                            contentOfPid = "";
                        }
                    }
                }
            });
        }
        return contentOfPid;
    }
};


function one(oldObj) {
    var newObj = {};
    if (oldObj && (typeof oldObj === 'undefined' ? 'undefined' : (0, _typeof3.default)(oldObj)) == "object") {
        for (var i in oldObj) {
            if ((0, _typeof3.default)(oldObj[i]) == "object") {

                newObj[i] = one(oldObj[i]);
            } else {
                newObj[i] = oldObj[i];
            }
        }
        return newObj;
    }
}

/***/ }),

/***/ 194:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _objectWithoutProperties2 = __webpack_require__(145);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'app',
  components: {},
  data: function data() {
    return {
      tableHeight: "",
      tableWidth: "",
      progressShow: false,
      percentage: 0
    };
  },
  provide: function provide() {
    return {
      exportPercentage: this.exportPercentage
    };
  },

  methods: {
    exportPercentage: function exportPercentage(name, url, params) {
      var _this = this;

      this.percentage = 0;

      var insuranceTypeList = params.insuranceTypeList,
          param = (0, _objectWithoutProperties3.default)(params, ["insuranceTypeList"]);


      this.progressShow = true;
      this.$axios({
        url: url,
        method: "get",
        responseType: "blob",
        params: param,
        onDownloadProgress: function onDownloadProgress(progressEvent) {
          var progressBar = Math.round(ProgressEvent.loaded / progressEvent.total * 100);
          _this.percentage = progressBar ? progressBar : 0;
        }
      }).then(function (res) {
        if (res.status != 200) {
          _this.$message.error("文件下载失败，请稍后再试！");
        }

        var blob = new Blob([res.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        });

        if (window.navigator && window.navigator.meSaveOrOpenBlob) {
          window.navigator.meSaveOrOpenBlob(blob, "文件名称.xlsx");
        } else {
          var link = document.createElement('a');
          var body = document.querySelector('body');
          link.href = window.URL.createObjectURL(blob);

          var timestamp = Date.parse(new Date());
          link.download = name + '-' + timestamp;

          link.style.display = "none";
          body.appendChild(link);
          link.click();
          body.removeChild(link);
          window.URL.revokeObjectURL(link.href);
        }

        _this.percentage = 100;
        _this.progressShow = false;
      }).catch(function (error) {
        _this.$message.error("文件下载失败，请联系管理员！");
        _this.progressShow = false;
      });
    }
  },
  mounted: function mounted() {
    this.tableHeight = window.innerHeight + 'px';
    this.tableWidth = window.innerWidth + 'px';
    var $this = this;

    window.onresize = function () {
      return function () {
        $this.tableHeight = window.innerHeight + 'px';
        $this.tableWidth = window.innerWidth + 'px';
      }();
    };
  }
};

/***/ }),

/***/ 195:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = __webpack_require__(44);

var _stringify2 = _interopRequireDefault(_stringify);

var _api = __webpack_require__(22);

var _jsMd = __webpack_require__(152);

var _jsMd2 = _interopRequireDefault(_jsMd);

var _vueCookies = __webpack_require__(23);

var _vueCookies2 = _interopRequireDefault(_vueCookies);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      currImgs: [],
      imgs: [__webpack_require__(372), __webpack_require__(371)],
      logonImg: __webpack_require__(116),
      index: 0,
      isTrue: true,
      tableHeight: "",
      tableWidth: "",

      loginData: {
        username: "",
        password: ""
      },
      loginRules: {
        username: [{ required: true, message: "请输入账号", trigger: "blur" }],
        password: [{ required: true, message: "请输入密码", trigger: "blur" }]
      },
      checked: true
    };
  },
  mounted: function mounted() {
    this.tableHeight = window.innerHeight + 'px';
    this.tableWidth = window.innerWidth + 'px';
    this.currImgs = [this.imgs[0]];
    this.startChange();
    window.addEventListener('keydown', this.keyDown);
  },

  methods: {
    getSysAdmin: function getSysAdmin() {
      var _this2 = this;

      (0, _api.getUserInfo)({}).then(function (res) {
        if (res) {
          var sysUserName = res.staff_name;
          sessionStorage.setItem("sysUserName", (0, _stringify2.default)(res));

          var t = _this2.$cookies.get('access_token');
          if (t && t !== "") {
            _this2.$router.push({ path: "/index" });

            sessionStorage.setItem("menuTabsValue", (0, _stringify2.default)(""));
            sessionStorage.setItem("menuTabs", (0, _stringify2.default)([]));
          }
        }
      }).catch(function (res) {
        _this2.$message("查询用户名异常");
      });
    },
    keyDown: function keyDown(e) {
      var _this3 = this;

      if (e.keyCode === 13) {
        this.$nextTick(function () {
          _this3.startLogin('loginForm');
        });
      }
    },
    startLogin: function startLogin(form) {
      var _this4 = this;

      this.$refs.loginForm.validate(function (valid) {
        if (valid) {
          _this4.$axios.post("/login", _this4.loginData).then(function (res) {
            _this4.$cookies.set('access_token', res.headers.authorization);

            if (res.data.success == false) {
              _this4.$message.error(res.data.errorMsg);
              return false;
            }
            _this4.getSysAdmin();
          }).catch(function (res) {
            _this4.$message('登录出错，请重试！');
          });
        } else {
          _this4.$message('请输入账号密码');
          return false;
        }
      });
    },
    initUserInfo: function initUserInfo(token) {
      var _this5 = this;

      (0, _api.GetUserSysInfo)({}).then(function (res) {
        if (res.code == 0 && res.info) {
          localStorage.setItem("userid", res.info.userid);
          localStorage.setItem("userName", res.info.uname);
          localStorage.setItem("userpk", res.info.userpk);
          localStorage.setItem("usermappingpk", res.info.usermappingpk);
          localStorage.setItem("orgpk", res.info.orgpk);
          localStorage.setItem("orgtype", res.info.orgtype);
          localStorage.setItem("orgcode", res.info.orgcode);
          localStorage.setItem("cnname", res.info.cnname);
          localStorage.setItem("enname", res.info.enname);
          localStorage.setItem("menuList", (0, _stringify2.default)(res.info.menuList));
          localStorage.setItem("funcList", (0, _stringify2.default)(res.info.funcList));
          _this5.$router.push({ path: "/" });
        } else {}
      }).catch(function (res) {});
    },

    startChange: function startChange() {
      var _this = this;
      setInterval(function () {
        if (_this.index < _this.imgs.length - 1) {
          _this.index++;
        } else {
          _this.index = 0;
        }
        _this.currImgs.splice(0, 1, _this.imgs[_this.index]);
      }, 9000);
    }

  }
};

/***/ }),

/***/ 196:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vueCookies = __webpack_require__(23);

var _vueCookies2 = _interopRequireDefault(_vueCookies);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'NavMenu',
  props: ['navMenus'],
  data: function data() {
    return {
      cusUrl: "https://huayang-in.com/HYIECB-v1.0",
      access_token: _vueCookies2.default.get("access_token")
    };
  },

  methods: {
    openNewpage: function openNewpage(data) {
      window.open(this.cusUrl + '/gcsite/toFineReport?reportName=' + data + '&access_token=' + this.access_token);
    }
  }
};

/***/ }),

/***/ 197:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _api = __webpack_require__(22);

exports.default = {
  name: "reloginPage",
  data: function data() {
    return {
      reLoginDialogVisible: true,
      loginData: {
        username: "",
        password: ""
      },
      loginRules: {
        username: [{ required: true, message: "请输入账号", trigger: "blur" }],
        password: [{ required: true, message: "请输入密码", trigger: "blur" }]
      }
    };
  },

  methods: {
    startLogin: function startLogin(form) {
      var _this = this;

      this.$refs[form].validate(function (valid) {
        if (valid) {
          sessionStorage.setItem("go", true);
          _this.$axios.post("/login", _this.loginData).then(function (res) {
            if (res.data.success === false) {
              _this.$message.error(res.data.errorMsg);
              return false;
            }

            _this.$cookies.set('access_token', res.headers.authorization);
            _this.getSysAdmin();
          }).catch(function (err) {
            _this.$message('登录出错，请重试！');
          });
        } else {
          _this.$message('请输入账号密码');
          return false;
        }
      });
    },
    getSysAdmin: function getSysAdmin() {
      var _this2 = this;

      (0, _api.getUserInfo)({}).then(function (res) {
        if (res) {
          var oldData = JSON.parse(sessionStorage.getItem("sysUserName"));

          if (res.password !== oldData.password || res.staff_name !== oldData.staff_name) {
            location.href = 'https://huayang-in.com/hybb/#/loginForm';
            sessionStorage.clear();
            localStorage.clear();
          }

          _this2.reLoginDialogVisible = false;
        }
      }).catch(function (res) {
        _this2.$message("查询用户名异常");
      });
    }
  }
};

/***/ }),

/***/ 198:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    created: function created() {}
};

/***/ }),

/***/ 199:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = __webpack_require__(44);

var _stringify2 = _interopRequireDefault(_stringify);

var _NavMenu = __webpack_require__(376);

var _NavMenu2 = _interopRequireDefault(_NavMenu);

var _api = __webpack_require__(22);

var _vueCookies = __webpack_require__(23);

var _vueCookies2 = _interopRequireDefault(_vueCookies);

var _updateUserPassword = __webpack_require__(381);

var _updateUserPassword2 = _interopRequireDefault(_updateUserPassword);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  components: { UpdateUserPassword: _updateUserPassword2.default, NavMenu: _NavMenu2.default },
  data: function data() {
    return {
      menuShow: true,

      menuTabs: [{ title: "首页", name: "/index", content: "/index" }],

      menuTabsValue: "/index",
      sessionWidth: "",

      keepArrary: [],

      menuList: [],
      collapsed: false,

      leftNovWidth: "248px",
      titleLogo: true,
      sysUserName: "",
      updatePassword: {
        sysUserCode: "",
        visible: false
      },
      sysUserAvatar: __webpack_require__(373),
      headerImg: __webpack_require__(116)
    };
  },
  created: function created() {
    var keepArrary = JSON.parse(sessionStorage.getItem("keepArrary"));
    if (keepArrary) {
      this.keepArrary = JSON.parse(sessionStorage.getItem("keepArrary"));
    }
  },
  mounted: function mounted() {
    this.getHomeMenuList();
    var sysUser = JSON.parse(sessionStorage.getItem('sysUserName'));
    this.sysUserName = sysUser["staff_name"];
    this.updatePassword.sysUserCode = sysUser["staff_code"];
    this.sessionWidth = window.innerWidth - 248 + "px";
    this.menuTabsValue = JSON.parse(sessionStorage.getItem("menuTabsValue"));
    this.menuTabs = JSON.parse(sessionStorage.getItem("menuTabs"));
    if (this.menuTabsValue == "" || this.menuTabsValue == undefined) {
      this.menuTabsValue = "/index";
    }
    if (this.menuTabs == [] || this.menuTabs == undefined) {
      this.menuTabs = [{ title: "首页", name: "/index", content: "/index" }];
    }
  },

  computed: {
    key: function key() {
      if (this.$route.path === "/companyStandardManager") {
        return this.$route.fullPath;
      } else {
        return this.$route.path;
      }
    }
  },
  watch: {
    $route: {
      handler: function handler(to, from) {
        var _this2 = this;

        if (to.path === "/") {}
        if (to.fullPath.indexOf("/warrantyDetail") != -1) {
          this.menuTabs = JSON.parse(sessionStorage.getItem("menuTabs"));
          var flage = this.menuTabs.some(function (item) {
            return item.content == to.fullPath;
          });
          if (!flage) {
            this.menuTabs.push({
              title: to.name,
              name: to.fullPath,
              content: to.fullPath
            });
          }
          var delTabs = JSON.parse(sessionStorage.getItem("delTabs"));
          this.menuTabs.forEach(function (item, index) {
            if (item.content == delTabs) {
              _this2.menuTabs.splice(index, 1);
            }
          });
          this.keepArrary.forEach(function (item, index) {
            if (delTabs == "/" + item) {
              _this2.keepArrary.splice(index, 1);
            }
          });
          sessionStorage.setItem("delTabs", (0, _stringify2.default)(""));
          this.menuTabsValue = to.fullPath;
          sessionStorage.setItem("menuTabsValue", (0, _stringify2.default)(this.menuTabsValue));
          sessionStorage.setItem("menuTabs", (0, _stringify2.default)(this.menuTabs));
        } else if (to.fullPath.indexOf("/warrantyChange") != -1) {
          this.menuTabs = JSON.parse(sessionStorage.getItem("menuTabs"));
          var flage = this.menuTabs.some(function (item) {
            return item.content == to.fullPath;
          });
          if (!flage) {
            this.menuTabs.push({
              title: to.name,
              name: to.fullPath,
              content: to.fullPath
            });
          }
          var delTabs = JSON.parse(sessionStorage.getItem("delTabs"));
          this.menuTabs.forEach(function (item, index) {
            if (item.content == delTabs) {
              _this2.menuTabs.splice(index, 1);
            }
          });
          this.keepArrary.forEach(function (item, index) {
            if (delTabs == "/" + item) {
              _this2.keepArrary.splice(index, 1);
            }
          });
          sessionStorage.setItem("delTabs", (0, _stringify2.default)(""));
          this.menuTabsValue = to.fullPath;
          sessionStorage.setItem("menuTabsValue", (0, _stringify2.default)(this.menuTabsValue));
          sessionStorage.setItem("menuTabs", (0, _stringify2.default)(this.menuTabs));
        } else if (to.fullPath.indexOf("/enquiryDetail") != -1) {
          this.menuTabs = JSON.parse(sessionStorage.getItem("menuTabs"));
          var flage = this.menuTabs.some(function (item) {
            return item.content == to.fullPath;
          });
          if (!flage) {
            this.menuTabs.push({
              title: to.name,
              name: to.fullPath,
              content: to.fullPath
            });
          }
          var delTabs = JSON.parse(sessionStorage.getItem("delTabs"));
          this.menuTabs.forEach(function (item, index) {
            if (item.content == delTabs) {
              _this2.menuTabs.splice(index, 1);
            }
          });
          this.keepArrary.forEach(function (item, index) {
            if (delTabs == "/" + item) {
              _this2.keepArrary.splice(index, 1);
            }
          });
          sessionStorage.setItem("delTabs", (0, _stringify2.default)(""));
          this.menuTabsValue = to.fullPath;
          sessionStorage.setItem("menuTabsValue", (0, _stringify2.default)(this.menuTabsValue));
          sessionStorage.setItem("menuTabs", (0, _stringify2.default)(this.menuTabs));
        } else if (to.fullPath.indexOf("/insuranceCompany") !== -1) {
          var str = to.path.substr(1);
          if (this.keepArrary.indexOf(str) == -1) {
            this.keepArrary.push(str);
          }
          sessionStorage.setItem("keepArrary", (0, _stringify2.default)(this.keepArrary));
          this.menuTabs = JSON.parse(sessionStorage.getItem("menuTabs"));
          var flage = this.menuTabs.some(function (item) {
            return item.content === to.fullPath;
          });
          if (!flage) {
            this.menuTabs.push({
              title: to.name,
              name: to.fullPath,
              content: to.fullPath
            });
          }
          var delTabs = JSON.parse(sessionStorage.getItem("delTabs"));
          this.menuTabs.forEach(function (item, index) {
            if (item.content == delTabs) {
              _this2.menuTabs.splice(index, 1);
            }
          });
          this.keepArrary.forEach(function (item, index) {
            if (delTabs == "/" + item) {
              _this2.keepArrary.splice(index, 1);
            }
          });
          sessionStorage.setItem("delTabs", (0, _stringify2.default)(""));
          this.menuTabsValue = to.fullPath;
          sessionStorage.setItem("menuTabsValue", (0, _stringify2.default)(this.menuTabsValue));
          sessionStorage.setItem("menuTabs", (0, _stringify2.default)(this.menuTabs));
        } else if (to.fullPath.indexOf("/claimDetail") !== -1) {
          this.menuTabs = JSON.parse(sessionStorage.getItem("menuTabs"));
          var flag = this.menuTabs.some(function (item) {
            return item.content === to.fullPath;
          });
          if (!flag) {
            this.menuTabs.push({
              title: to.name,
              name: to.fullPath,
              content: to.fullPath
            });
          }
          var delTabs = JSON.parse(sessionStorage.getItem("delTabs"));
          this.menuTabs.forEach(function (item, index) {
            if (item.content == delTabs) {
              _this2.menuTabs.splice(index, 1);
            }
          });
          this.keepArrary.forEach(function (item, index) {
            if (delTabs == "/" + item) {
              _this2.keepArrary.splice(index, 1);
            }
          });
          sessionStorage.setItem("delTabs", (0, _stringify2.default)(""));
          this.menuTabsValue = to.fullPath;
          sessionStorage.setItem("menuTabsValue", (0, _stringify2.default)(this.menuTabsValue));
          sessionStorage.setItem("menuTabs", (0, _stringify2.default)(this.menuTabs));
        } else if (to.fullPath.indexOf("/claimHis") !== -1) {
          this.menuTabs = JSON.parse(sessionStorage.getItem("menuTabs"));
          var _flag = this.menuTabs.some(function (item) {
            return item.content === to.fullPath;
          });
          if (!_flag) {
            this.menuTabs.push({
              title: to.name,
              name: to.fullPath,
              content: to.fullPath
            });
          }
          var delTabs = JSON.parse(sessionStorage.getItem("delTabs"));
          this.menuTabs.forEach(function (item, index) {
            if (item.content == delTabs) {
              _this2.menuTabs.splice(index, 1);
            }
          });
          this.keepArrary.forEach(function (item, index) {
            if (delTabs == "/" + item) {
              _this2.keepArrary.splice(index, 1);
            }
          });
          sessionStorage.setItem("delTabs", (0, _stringify2.default)(""));
          this.menuTabsValue = to.fullPath;
          sessionStorage.setItem("menuTabsValue", (0, _stringify2.default)(this.menuTabsValue));
          sessionStorage.setItem("menuTabs", (0, _stringify2.default)(this.menuTabs));
        } else if (to.fullPath == "/warrantyAdd") {
          var str = to.path.substr(1);
          if (this.keepArrary.indexOf(str) == -1) {
            this.keepArrary.push(str);
          }
          sessionStorage.setItem("keepArrary", (0, _stringify2.default)(this.keepArrary));
          this.menuTabs = JSON.parse(sessionStorage.getItem("menuTabs"));
          var flage = this.menuTabs.some(function (item) {
            return item.content == to.fullPath;
          });
          if (!flage) {
            this.menuTabs.push({
              title: to.name,
              name: to.fullPath,
              content: to.fullPath
            });
          }
          var delTabs = JSON.parse(sessionStorage.getItem("delTabs"));
          this.menuTabs.forEach(function (item, index) {
            if (item.content == delTabs) {
              _this2.menuTabs.splice(index, 1);
            }
          });
          this.keepArrary.forEach(function (item, index) {
            if (delTabs == "/" + item) {
              _this2.keepArrary.splice(index, 1);
            }
          });
          sessionStorage.setItem("delTabs", (0, _stringify2.default)(""));
          this.menuTabsValue = to.fullPath;
          sessionStorage.setItem("menuTabsValue", (0, _stringify2.default)(this.menuTabsValue));
          sessionStorage.setItem("menuTabs", (0, _stringify2.default)(this.menuTabs));
        } else {
          var str = to.path.substr(1);
          if (this.keepArrary.indexOf(str) == -1) {
            this.keepArrary.push(str);
          }
          sessionStorage.setItem("keepArrary", (0, _stringify2.default)(this.keepArrary));
          this.menuTabs = JSON.parse(sessionStorage.getItem("menuTabs"));
          var flage = this.menuTabs.some(function (item) {
            return item.content == to.fullPath;
          });
          if (!flage) {
            this.menuTabs.push({
              title: to.name,
              name: to.fullPath,
              content: to.fullPath
            });
          }
          var delTabs = JSON.parse(sessionStorage.getItem("delTabs"));
          this.menuTabs.forEach(function (item, index) {
            if (item.content == delTabs) {
              _this2.menuTabs.splice(index, 1);
            }
          });
          this.keepArrary.forEach(function (item, index) {
            if (delTabs == "/" + item) {
              _this2.keepArrary.splice(index, 1);
            }
          });
          sessionStorage.setItem("delTabs", (0, _stringify2.default)(""));
          this.menuTabsValue = to.fullPath;
          sessionStorage.setItem("menuTabsValue", (0, _stringify2.default)(this.menuTabsValue));
          sessionStorage.setItem("menuTabs", (0, _stringify2.default)(this.menuTabs));
        }
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    menuShowChange: function menuShowChange() {
      this.menuShow = !this.menuShow;
    },
    updatePasswordDialog: function updatePasswordDialog() {
      this.updatePassword.visible = true;
    },
    closeDialog: function closeDialog() {
      this.updatePassword.visible = false;
    },
    logOUt: function logOUt() {
      var _this3 = this;

      this.$confirm("是否确认退出登录?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(function () {
        sessionStorage.clear();
        localStorage.clear();
        _this3.$cookies.remove("access_token");
        location.href = 'https://huayang-in.com/hybb/#/loginForm';
        _this3.$message({
          type: "success",
          message: "退出成功!"
        });
      });
    },
    getHomeMenuList: function getHomeMenuList() {
      var _this4 = this;

      (0, _api.getMenuList)({}).then(function (res) {
        if (res.success) {
          _this4.menuList = res.data;
          sessionStorage.setItem("menuList", (0, _stringify2.default)(_this4.menuList));

          _this4.$nextTick(function () {
            var node = document.getElementById("RSTZ");
            node.style.setProperty('padding-left', node.style.paddingLeft, 'important');
            node.style.setProperty('color', "#303133");
            node.style.setProperty('font-size', "14px", 'important');
          });
        }
      }).catch(function (res) {
        _this4.$message("查询异常");
      });
    },
    subClick: function subClick(child) {
      if (child.subFunc && child.subFunc.length > 0) {
        $router.push(child.routeurl);
      }
    },
    addTab: function addTab(targetName, contentUrl) {
      var str = contentUrl.substring(1);

      if (this.keepArrary.indexOf(str) === -1) {
        this.keepArrary.push(str);
      }
      sessionStorage.setItem("keepArrary", (0, _stringify2.default)(this.keepArrary));

      var newTabName = contentUrl;

      var tabs = this.menuTabs;
      var isOpen = false;
      tabs.forEach(function (tab, index) {
        if (tab.name === newTabName) {
          isOpen = true;
        }
      });

      if (!isOpen) {
        this.menuTabs.push({
          title: targetName,
          name: contentUrl,
          content: contentUrl
        });
      }

      this.menuTabsValue = contentUrl;
      sessionStorage.setItem("menuTabsValue", (0, _stringify2.default)(this.menuTabsValue));
      sessionStorage.setItem("menuTabs", (0, _stringify2.default)(this.menuTabs));
    },
    removeTab: function removeTab(targetName) {
      var _this5 = this;

      var remove = "";
      this.keepArrary.forEach(function (item, index) {
        var pattern = new RegExp("^/" + item);
        if (pattern.test(targetName)) {
          _this5.keepArrary.splice(index, 1);
          remove = "/" + item;
        }
      });

      sessionStorage.setItem("keepArrary", (0, _stringify2.default)(this.keepArrary));

      var pathList = this.$root.pathList;
      var routesNumMap = this.$root.routesNumMap;
      var path = pathList.find(function (e) {
        var pattern = new RegExp("^" + e);
        if (pattern.test(targetName)) return e;
      });

      if (path) {
        var pattern = new RegExp("^" + path);
        path = path.substring(1);
        var arr = this.$router.options.routes[routesNumMap[path]["number"]].children;

        for (var i = 0; i < arr.length; i++) {
          if (arr[i].path === remove) {
            arr.splice(i, 1);
          }
        }

        var routeNum = JSON.parse(sessionStorage.getItem(routesNumMap[path]["routeName"]));
        if (routeNum) {
          routeNum = routeNum.filter(function (item) {
            return item.path !== remove;
          });
          sessionStorage.setItem(routesNumMap[path]["routeName"], (0, _stringify2.default)(routeNum));
        }
      }

      var tabs = this.menuTabs;
      var activeName = this.menuTabsValue;

      if (targetName === "/index") return;
      if (activeName === targetName) {
        tabs.forEach(function (tab, index) {
          if (tab.name === targetName) {
            var nextTab = tabs[index + 1] || tabs[index - 1];
            if (nextTab) {
              activeName = nextTab.name;
            }
          }
        });
      }
      this.menuTabsValue = activeName;
      if (this.menuTabsValue) this.menuTabs = tabs.filter(function (tab) {
        return tab.name !== targetName;
      });
      this.$router.push({ path: this.menuTabsValue });
      sessionStorage.setItem("menuTabsValue", (0, _stringify2.default)(this.menuTabsValue));
      sessionStorage.setItem("menuTabs", (0, _stringify2.default)(this.menuTabs));
    },
    addNewtap: function addNewtap(targetName) {
      if (targetName === "全部关闭") {
        this.menuTabs = [{ title: "首页", name: "/index", content: "/index" }];
        this.menuTabsValue = "/index";
        sessionStorage.setItem("menuTabsValue", (0, _stringify2.default)(this.menuTabsValue));
        sessionStorage.setItem("menuTabs", (0, _stringify2.default)(this.menuTabs));
        this.keepArrary = [];
        sessionStorage.setItem("keepArrary", (0, _stringify2.default)(this.keepArrary));
        this.$router.push({ path: "/index" });
      } else {
        this.$router.push({ path: targetName });
      }
    },
    onSubmit: function onSubmit() {},
    handleopen: function handleopen() {},
    handleclose: function handleclose() {},

    handleselect: function handleselect(a, b) {},

    gochangpwel: function gochangpwel() {
      var _this = this;
      this.$confirm("确认修改密码吗?", "提示", {}).then(function () {
        _this.$router.push("/changpwd");
      }).catch(function () {});
    },
    goQiantai: function goQiantai() {
      window.location.href = "../html/jnIndex.html?v=2020041901";
    },

    collapse: function collapse() {
      this.collapsed = !this.collapsed;
      if (this.collapsed) {

        this.leftNovWidth = "64px";
      } else {
        this.leftNovWidth = "220px";
        this.titleLogo = true;
      }
    },
    showMenu: function showMenu(i, status) {
      this.$refs.menuCollapsed.getElementsByClassName("submenu-hook-" + i)[0].style.display = status ? "block" : "none";
    }
  }
};

/***/ }),

/***/ 200:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _api = __webpack_require__(22);

exports.default = {
    data: function data() {
        return {
            loginUrl: '',
            backUrl: ''
        };
    },

    methods: {}
};

/***/ }),

/***/ 201:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _api = __webpack_require__(22);

exports.default = {
    data: function data() {
        return {
            ruleForm2: {
                acid: null,
                creator: null,
                factoryid: null,
                newpass: null,
                newlpass: null,
                oldpass: null,
                uid: null
            },

            rules2: {
                oldpass: [{ required: true, message: "请输入原密码", trigger: "blur" }],
                newpass: [{ required: true, message: "请输入新密码", trigger: "blur" }, { min: 6, message: '长度小于6个字符', trigger: 'blur' }, { max: 20, message: '长度大于 20个字符', trigger: 'blur' }],
                newlpass: [{ required: true, message: "请输入确认密码", trigger: "blur" }, { min: 6, message: '长度小于6个字符', trigger: 'blur' }, { max: 20, message: '长度大于 20个字符', trigger: 'blur' }]
            }
        };
    },
    mounted: function mounted() {},

    methods: {
        handleSubmit: function handleSubmit(ev) {
            var _this = this;

            if (this.ruleForm2.newpass === this.ruleForm2.newlpass) {
                this.$refs.ruleForm2.validate(function (valid) {
                    if (valid) {
                        var param = {
                            userpk: localStorage.getItem("userpk"),
                            oldPwd: _this.ruleForm2.oldpass,
                            newPwd: _this.ruleForm2.newpass
                        };
                        (0, _api.ModifyUserPwd)(param).then(function (res) {
                            if (res.code !== 0) {
                                _this.$message({
                                    message: res.msg,
                                    type: "error"
                                });
                            } else {
                                _this.$message({
                                    message: res.msg,
                                    type: "success"
                                });
                                location.href = "/html/login.html";
                            }
                        });
                    }
                });
            } else {
                this.$message({
                    message: '新密码俩次输入不相同',
                    type: "error"
                });
            }
        }
    }
};

/***/ }),

/***/ 202:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _api = __webpack_require__(22);

exports.default = {
  name: "updateUserPassword",
  props: ["visible", "userCode"],
  data: function data() {
    return {
      dataObject: {
        oldPassword: "",
        newPassWord: "",
        checkNewPassWord: ""
      }
    };
  },
  watch: {},
  methods: {
    update: function update() {
      var _this = this;

      if (this.dataObject.newPassWord !== this.dataObject.checkNewPassWord) {
        this.$message.error('新密码和确认密码不一致！');
        return;
      }

      var params = {
        staffCode: this.userCode,
        oldPassword: this.dataObject.oldPassword,
        newPassWord: this.dataObject.newPassWord
      };

      (0, _api.updateStaffPassword)(params).then(function (res) {
        if (res.success) {
          _this.$message.success(res.data);
          _this.handleClose();
        } else {
          _this.$message.error(res.data);
        }
      }).catch(function (error) {
        _this.$message.error('请求出错，请稍后重试！');
      });
    },
    handleClose: function handleClose() {
      this.dataObject = {
        oldPassword: "",
        newPassWord: "",
        checkNewPassWord: ""
      };
      this.$emit("close");
    }
  }
};

/***/ }),

/***/ 203:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _promise = __webpack_require__(43);

var _promise2 = _interopRequireDefault(_promise);

var _extends2 = __webpack_require__(32);

var _extends3 = _interopRequireDefault(_extends2);

var _keys = __webpack_require__(88);

var _keys2 = _interopRequireDefault(_keys);

var _vue = __webpack_require__(4);

var _vue2 = _interopRequireDefault(_vue);

var _App = __webpack_require__(132);

var _App2 = _interopRequireDefault(_App);

__webpack_require__(128);

var _elementUi = __webpack_require__(123);

var _elementUi2 = _interopRequireDefault(_elementUi);

var _vueRouter = __webpack_require__(70);

var _vueRouter2 = _interopRequireDefault(_vueRouter);

var _store = __webpack_require__(120);

var _store2 = _interopRequireDefault(_store);

var _vuex = __webpack_require__(71);

var _vuex2 = _interopRequireDefault(_vuex);

var _vueAwesomeSwiper = __webpack_require__(130);

var _vueAwesomeSwiper2 = _interopRequireDefault(_vueAwesomeSwiper);

var _routes = __webpack_require__(119);

var _routes2 = _interopRequireDefault(_routes);

var _common = __webpack_require__(117);

var _common2 = _interopRequireDefault(_common);

var _axios = __webpack_require__(69);

var _axios2 = _interopRequireDefault(_axios);

var _filter = __webpack_require__(87);

var _filter2 = _interopRequireDefault(_filter);

var _vueCookies = __webpack_require__(23);

var _vueCookies2 = _interopRequireDefault(_vueCookies);

__webpack_require__(118);

__webpack_require__(126);

__webpack_require__(127);

__webpack_require__(124);

var _vueSplitterPane = __webpack_require__(134);

var _vueSplitterPane2 = _interopRequireDefault(_vueSplitterPane);

var _vViewer = __webpack_require__(129);

var _vViewer2 = _interopRequireDefault(_vViewer);

var _reloginPage = __webpack_require__(133);

var _reloginPage2 = _interopRequireDefault(_reloginPage);

__webpack_require__(125);

var _filter3 = __webpack_require__(81);

var filters = _interopRequireWildcard(_filter3);

var _vueFullcalendar = __webpack_require__(131);

var _vueFullcalendar2 = _interopRequireDefault(_vueFullcalendar);

var _decimal = __webpack_require__(121);

var _decimal2 = _interopRequireDefault(_decimal);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.use(_vViewer2.default);
_vue2.default.use(_vueSplitterPane2.default);

(0, _keys2.default)(filters).forEach(function (key) {
    _vue2.default.filter(key, filters[key]);
});

_vue2.default.component('full-calendar', _vueFullcalendar2.default);
var ElTreeGrid = __webpack_require__(122);
(0, _keys2.default)(_filter2.default).forEach(function (k) {
    return _vue2.default.filter(k, _filter2.default[k]);
});
_vue2.default.use(_elementUi2.default);

_vue2.default.use(_vueRouter2.default);
_vue2.default.use(_vuex2.default);
_vue2.default.use(_common2.default);
_vue2.default.use(_vueCookies2.default);
_vue2.default.component(ElTreeGrid.name, ElTreeGrid);
_vue2.default.use(_vueAwesomeSwiper2.default);
_vue2.default.prototype.$axios = _axios2.default;

_vue2.default.prototype.$decimal = _decimal2.default;
_axios2.default.defaults.baseURL = "https://huayang-in.com/HYIECB-v1.0";

_axios2.default.defaults.headers.common['Authorization'] = '';
_axios2.default.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';

var router = new _vueRouter2.default({
    base: __webpack_require__.i({"NODE_ENV":"production","ENV_CONFIG":"prod","API_ROOT":"https://huayang-in.com/HYIECB-v1.0","API_FRONT_ROOT":'https://huayang-in.com/hybb/#/loginForm'}).BASE_URL,
    routes: _routes2.default
});

var pathList = ["/warrantyDetail", "/warrantyChange", "/enquiryDetail", "/noCooperation", "/managerNocooperative", "/Cooperative", "/managerCooperative", "/claimDetail"];
var routesNumMap = {
    warrantyDetail: {
        requireCase: '1',
        number: 9,
        routeName: "routeNum"
    },
    warrantyChange: {
        requireCase: '2',
        number: 9,
        routeName: "routeNum"

    },
    enquiryDetail: {
        requireCase: '3',
        number: 10,
        routeName: "enquiryRoute"
    },
    noCooperation: {
        requireCase: '4',
        number: 15,
        routeName: "userRoute"
    },
    managerNocooperative: {
        requireCase: '5',
        number: 16,
        routeName: "userMangerRoute"
    },
    Cooperative: {
        requireCase: '6',
        number: 15,
        routeName: "userRoute"
    },
    managerCooperative: {
        requireCase: '7',
        number: 16,
        routeName: "userMangerRoute"
    },
    claimDetail: {
        requireCase: '8',
        number: 5,
        routeName: "claimRouteNum"
    }
};

function setComponent(route, key) {
    switch (key) {
        case '1':
            route.component = function (resolve) {
                return __webpack_require__.e/* require */(3).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(80)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
            };
            break;
        case '2':
            route.component = function (resolve) {
                return __webpack_require__.e/* require */(7).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(84)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
            };
            break;
        case '3':
            route.component = function (resolve) {
                return __webpack_require__.e/* require */(0).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(144)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
            };
            break;
        case '4':
            route.component = function (resolve) {
                return __webpack_require__.e/* require */(5).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(83)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
            };
            break;
        case '5':
            route.component = function (resolve) {
                return __webpack_require__.e/* require */(2).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(86)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
            };
            break;
        case '6':
            route.component = function (resolve) {
                return __webpack_require__.e/* require */(4).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(82)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
            };
            break;
        case '7':
            route.component = function (resolve) {
                return __webpack_require__.e/* require */(1).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(85)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
            };
            break;
        case '8':
            route.component = function (resolve) {
                return __webpack_require__.e/* require */(8).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(89)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
            };
            break;
        default:
            console.log('传入类型错误！');
            break;
    }
}

router.beforeEach(function (to, from, next) {
    var path = pathList.find(function (e) {
        var pattern = new RegExp("^" + e);
        if (pattern.test(to["fullPath"])) return e;
    });

    if (path) {
        var pattern = new RegExp("^" + path);
        path = path.substring(1);
        var flag = false;
        var arr = router.options.routes[routesNumMap[path]["number"]].children;
        for (var i = 0; i < arr.length; i++) {
            if (arr[i].path.indexOf(to["path"]) !== -1) {
                flag = true;
            }
        }

        if (!flag) {
            var routeNumber = JSON.parse(sessionStorage.getItem(routesNumMap[path]["routeName"]));
            if (routeNumber && routeNumber.length !== 0) {
                var set = [];
                routeNumber.forEach(function (e) {
                    var exit = set.find(function (s) {
                        if (s.path === e.path) return e;
                    });

                    if (!exit) {
                        set.push(e);
                    }
                });

                set.forEach(function (e) {
                    if (pattern.test(e.path)) {
                        setComponent(e, routesNumMap[path]["requireCase"]);
                    }
                });

                router.options.routes[routesNumMap[path]["number"]].children = router.options.routes[routesNumMap[path]["number"]].children.concat(set);
                router.addRoutes(router.options.routes);
                next((0, _extends3.default)({}, to, { replace: false }));
            }
        } else {
            next();
        }

        return;
    }

    if (to["path"] === '/loginForm') {
        sessionStorage.setItem('access_lose', 0);

        localStorage.clear();
        sessionStorage.clear();
    }
    next();
});

new _vue2.default({
    router: router,
    data: function data() {
        return {
            pathList: pathList,
            routesNumMap: routesNumMap,
            exportDisabledTime: 1000,
            customerType: [{ label: "内贸", value: "0" }, { label: "外贸", value: "1" }, { label: "内外贸兼营", value: "2" }],
            pageSize: [10, 20, 40, 60, 80, 100, 200, 300] };
    },
    store: _store2.default,
    render: function render(h) {
        return h(_App2.default);
    }
}).$mount('#app');

_axios2.default.interceptors.request.use(function (config) {
    if (config.url.indexOf("/login") <= 0) {
        var access_token = _vueCookies2.default.get('access_token');
        if (access_token && access_token.length > 0) {
            config.headers['Authorization'] = access_token;
        }
    }
    config.headers['terminalType'] = "4";
    return config;
}, function (err) {
    return _promise2.default.reject(err);
});

_axios2.default.interceptors.response.use(function (response) {
    if (response && typeof response["headers"] !== "undefined" && typeof response["headers"]["authorization"] !== "undefined") {
        var newToken = response["headers"]["authorization"];
        _vueCookies2.default.set('access_token', newToken);
    }

    if (response && (response.errorCode == '1005' || response.data.errorCode == '2010')) {
        var item = sessionStorage.getItem('access_lose');

        if (!item || item != 1) {
            sessionStorage.setItem('access_lose', '1');
            _elementUi.MessageBox.alert('登录失效，请重新登录!', '操作提醒', {
                confirmButtonText: '确定',
                callback: function callback(action) {
                    var instance = new _vue2.default({
                        el: document.createElement("div"),
                        render: function render(h) {
                            return h(_reloginPage2.default);
                        }
                    });

                    document.body.appendChild(instance.$el);
                }
            });
        }
    }

    return response;
});

/***/ }),

/***/ 204:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var increment = exports.increment = function increment(_ref) {
    var commit = _ref.commit;

    commit('INCREMENT');
};
var decrement = exports.decrement = function decrement(_ref2) {
    var commit = _ref2.commit;

    commit('DECREMENT');
};

/***/ }),

/***/ 205:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var getCount = exports.getCount = function getCount(state) {
    return state.count;
};

/***/ }),

/***/ 22:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.setFirstCommCompany = exports.deleteCommCompany = exports.updateCommCompany = exports.queryCommCompanyList = exports.addCommCompany = exports.userUnban = exports.userBan = exports.updateUrgentFollow = exports.updateUrgentState = exports.getUrgentList = exports.updateInquiryToWait = exports.contactRemarkQuery = exports.contactRemarkBatchUpdate = exports.claimQuerySum = exports.changeOfTheSubjectVestedCustomer = exports.queryPremiumBrokerageRatio = exports.batchModificationOfCommissionRate = exports.commissionStatisticsList = exports.commissionStatistics = exports.shipNameChange = exports.customerSellerChange = exports.customerNameChange = exports.customerUpdatePoint = exports.updateStaffPassword = exports.querySubjectFollowUpList = exports.addSubjectFollowUpOperate = exports.queryInquiredList = exports.compensationSituationCountQuery = exports.compensationSituationQuery = exports.affiliatedCompanyDelete = exports.affiliatedCompanyAdd = exports.insurancesubjectContentSave = exports.insurancesubjectDetail = exports.checkInsuranceSubjectState = exports.queryClaimList = exports.inquiryDiscard = exports.renewPolicyDelete = exports.censusSignList = exports.sellerAchTargetQuery = exports.signAchQuery = exports.companyAchTargetQuery = exports.companyAchTargetSave = exports.companyAchCount = exports.changeSubjectName = exports.lossWarrant = undefined;
exports.groupOfRoleList = exports.filePaperUpload = exports.policyDetailInfo = exports.customerAllList = exports.inquiryManualNewPolicy = exports.inquiryManualLost = exports.manualLost = exports.queryAuditAskPolicyList = exports.queryAuditPolicyList = exports.queryPolicyList = exports.queryWillPolicyList = exports.claimManagerStatisticsList = exports.claimManagerList = exports.claimUserList = exports.turnToEnquiryPost = exports.CHMCountViewQuery = exports.CHMProcessingQuery = exports.claimHomeQuery = exports.policyQuery = exports.underWritingQuery = exports.invoiceListHomepage = exports.payPolicyListHomepage = exports.financialQuery = exports.insurancesubjectUpdate = exports.insurancesubjectDelete = exports.insurancesubjectAdd = exports.fileDownloadPost = exports.fileDelete = exports.fileQuery = exports.customerFileQuery = exports.jumpToCaseDetail = exports.claimDelete = exports.claimAddFileQuery = exports.withdraw = exports.closeCase = exports.remainderCancel = exports.remainderChange = exports.remainderValid = exports.getHisPage = exports.claimDetail = exports.updateClaim = exports.updateClaimDetail = exports.saveClaim = exports.getHis = exports.getNoticePage = exports.addClaimFollowRecord = exports.claimVisitNeedUpdate = exports.claimVisitUpdate = exports.getVisitQuery = exports.getPage = exports.getCrmList = exports.getCode = exports.noticeUpdate = exports.noticeList = exports.noticeDelete = exports.noticeDetail = exports.noticeSave = exports.caseUpdate = exports.caseQuery = exports.caseDelete = exports.caseDetail = exports.caseSave = exports.questionFeedback = exports.questionQuery = exports.fileUploadListQuery = exports.fileListQuery = exports.filePaperDelete = exports.questionDelete = exports.fileUpdate = exports.questionUpdate = exports.fileDetailWithFeed = exports.questionDetailWithFeed = exports.questionAllList = exports.questionDetail = exports.questionSave = exports.fileSave = exports.paramGroupQueryByPid = exports.paramGroupQuery = exports.paramGroupUpdate = exports.batchRemoveParamGroup = exports.paramGroupAdd = exports.roleMenuButtonAlloc = exports.queryRoleMenuButtonAll = exports.buttonOfRoleQuery = exports.buttonQueryAll = exports.buttonQuery = exports.menuButtonAlloc = exports.batchRemoveButton = exports.buttonUpdate = exports.buttonSave = exports.getCurrentUserMenuList = exports.roleMenuAlloc = exports.queryRoleAllocMenu = exports.menuQueryAll = exports.menuListOfData = exports.menuList = exports.menuQuery = exports.batchRemoveMenu = exports.menuUpdate = exports.menuSave = undefined;
exports.userRoleAlloc = exports.roleQueryAll = exports.roleQueryRoleList = exports.roleQuery = exports.batchRemoveRole = exports.roleUpdate = exports.roleSave = exports.headerPic = exports.userQuery = exports.batchRemoveUser = exports.userUpdate = exports.userReset = exports.userSave = exports.userAdd = exports.inquiryfollowAdd = exports.inquiryWorker = exports.turnToEnquiry = exports.inquiryUpdateStatus = exports.inquiryUpdate = exports.inquiryDetail = exports.inquiryList = exports.inquiryWorkerList = exports.inquirySave = exports.fileDownload = exports.getMenuList = exports.payPolicyAduit = exports.manageCustomerRemark = exports.getAllcompany = exports.queryUserListOfRole = exports.distributionBatchRequest = exports.policyRenewLostback = exports.policyRenewdistribute = exports.policyReneListByPage = exports.policymainCorrectEdit = exports.policymainCorrect = exports.paypolicyqueryDetail = exports.checkPolicyNoExists = exports.policyQueryListByPage = exports.policyquerydelete = exports.policyqueryUpdate = exports.policyqueryDetail = exports.policymainSave = exports.queryListByPage = exports.queryClaimStatistics = exports.queryUnderwriteStatistics = exports.policyExcelForeign = exports.policyExcel = exports.invoiceExcel = exports.notifyClientBatchUpdate = exports.payPolicyupdateFiled = exports.payPolicyupdate = exports.claimUnpaidDetail = exports.payPolicyDetail = exports.payPolicyListForeign = exports.findClaimUnpaidList = exports.payPolicyList = exports.Getinvoiceoperate = exports.GetinvoiceDetailForeign = exports.GetinvoiceDetail = exports.GetinvoiceListForeign = exports.GetinvoiceList = exports.GetFinanceDetail = exports.batchUpdateFinance = exports.updateFinance = exports.GetFinanceListForeign = exports.GetFinanceList = exports.GetcompanyDel = exports.GetcompanyUpdate = exports.Getcompanydetail = exports.GetcompanySave = exports.GetcompanyList = exports.inquiryUpdateRenewBatch = exports.inquiryUpdateRenew = exports.inquiryUpdateState = exports.inquiryUpdateType = exports.manageCustomerUpdatSave = exports.manageCustomerUpdateDetail = exports.manageCustomerDetail = exports.manageCustomerList = exports.crmCustomersubject = exports.queryClaimReturnVisitCount = exports.queryClaimUnpaidCount = exports.claimUnpaidRelease = exports.crmCustomerGetclaim = exports.crmCustomerGetpolicy = exports.crmCustomerRelationList = exports.crmCustomerSellList = exports.crmCustomerAllList = exports.crmCustomerUpdateEnshrine = exports.crmCustomerfollowadd = exports.crmCustomerUpdate = exports.crmCustomerUpdatedetail = exports.crmCustomerdetail = exports.GetCustomerAdd = exports.GetCustomerlist = exports.inquiryLastDetail = exports.attachmentList = exports.checkCustomer = exports.getUserInfo = exports.GetUserSysInfot = undefined;

var _stringify = __webpack_require__(44);

var _stringify2 = _interopRequireDefault(_stringify);

var _axios = __webpack_require__(69);

var _axios2 = _interopRequireDefault(_axios);

var _vueCookies = __webpack_require__(23);

var _vueCookies2 = _interopRequireDefault(_vueCookies);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GetUserSysInfot = exports.GetUserSysInfot = function GetUserSysInfot(params) {
    return _axios2.default.post('/login', params).then(function (res) {
        return res.data;
    });
};
var getUserInfo = exports.getUserInfo = function getUserInfo(params) {
    return _axios2.default.post('/userInfo/userInfo', params).then(function (res) {
        return res.data;
    });
};
var checkCustomer = exports.checkCustomer = function checkCustomer(params) {
    return _axios2.default.post('/crm/customer/check', params).then(function (res) {
        return res.data;
    });
};

var attachmentList = exports.attachmentList = function attachmentList(params) {
    return _axios2.default.post('/attachment/list', params).then(function (res) {
        return res.data;
    });
};

var inquiryLastDetail = exports.inquiryLastDetail = function inquiryLastDetail(params) {
    return _axios2.default.post('/inquiry/last/detail', params).then(function (res) {
        return res.data;
    });
};
var GetCustomerlist = exports.GetCustomerlist = function GetCustomerlist(params) {
    return _axios2.default.post('/crm/customer/list', params).then(function (res) {
        return res.data;
    });
};
var GetCustomerAdd = exports.GetCustomerAdd = function GetCustomerAdd(params) {
    return _axios2.default.post('/crm/customer/add', params).then(function (res) {
        return res.data;
    });
};
var crmCustomerdetail = exports.crmCustomerdetail = function crmCustomerdetail(params) {
    return _axios2.default.post('/crm/customer/detail', params).then(function (res) {
        return res.data;
    });
};
var crmCustomerUpdatedetail = exports.crmCustomerUpdatedetail = function crmCustomerUpdatedetail(params) {
    return _axios2.default.post('/crm/customer/update/detail', params).then(function (res) {
        return res.data;
    });
};
var crmCustomerUpdate = exports.crmCustomerUpdate = function crmCustomerUpdate(params) {
    return _axios2.default.post('/crm/customer/update', params).then(function (res) {
        return res.data;
    });
};
var crmCustomerfollowadd = exports.crmCustomerfollowadd = function crmCustomerfollowadd(params) {
    return _axios2.default.post('/crm/customer/follow/add', params).then(function (res) {
        return res.data;
    });
};
var crmCustomerUpdateEnshrine = exports.crmCustomerUpdateEnshrine = function crmCustomerUpdateEnshrine(params) {
    return _axios2.default.post('/crm/customer/update/enshrine', params).then(function (res) {
        return res.data;
    });
};
var crmCustomerAllList = exports.crmCustomerAllList = function crmCustomerAllList(params) {
    return _axios2.default.post('/crm/customer/all/sell/list', params).then(function (res) {
        return res.data;
    });
};
var crmCustomerSellList = exports.crmCustomerSellList = function crmCustomerSellList(params) {
    return _axios2.default.post('/crm/customer/all/sell/sub/list', params).then(function (res) {
        return res.data;
    });
};
var crmCustomerRelationList = exports.crmCustomerRelationList = function crmCustomerRelationList(params) {
    return _axios2.default.post('/crm/customer/relation/list', params).then(function (res) {
        return res.data;
    });
};
var crmCustomerGetpolicy = exports.crmCustomerGetpolicy = function crmCustomerGetpolicy(params) {
    return _axios2.default.post('/policy/main/queryUnderwriteStatistics', params).then(function (res) {
        return res.data;
    });
};
var crmCustomerGetclaim = exports.crmCustomerGetclaim = function crmCustomerGetclaim(params) {
    return _axios2.default.post('/policy/claim/queryClaimStatistics', params).then(function (res) {
        return res.data;
    });
};
var claimUnpaidRelease = exports.claimUnpaidRelease = function claimUnpaidRelease(params) {
    return _axios2.default.post('/policy/claim/claimUnpaidRelease', params).then(function (res) {
        return res.data;
    });
};
var queryClaimUnpaidCount = exports.queryClaimUnpaidCount = function queryClaimUnpaidCount(params) {
    return _axios2.default.post('/pay/policy/queryClaimUnpaidCount', params).then(function (res) {
        return res.data;
    });
};

var queryClaimReturnVisitCount = exports.queryClaimReturnVisitCount = function queryClaimReturnVisitCount(params) {
    return _axios2.default.post('/policy/claim/queryClaimUnpaidCount', params).then(function (res) {
        return res.data;
    });
};
var crmCustomersubject = exports.crmCustomersubject = function crmCustomersubject(params) {
    return _axios2.default.post('/crm/customer/insurance/subject', params).then(function (res) {
        return res.data;
    });
};

var manageCustomerList = exports.manageCustomerList = function manageCustomerList(params) {
    return _axios2.default.post('/manage/customer/list', params).then(function (res) {
        return res.data;
    });
};
var manageCustomerDetail = exports.manageCustomerDetail = function manageCustomerDetail(params) {
    return _axios2.default.post('/manage/customer/detail', params).then(function (res) {
        return res.data;
    });
};
var manageCustomerUpdateDetail = exports.manageCustomerUpdateDetail = function manageCustomerUpdateDetail(params) {
    return _axios2.default.post('/manage/customer/update/detail', params).then(function (res) {
        return res.data;
    });
};
var manageCustomerUpdatSave = exports.manageCustomerUpdatSave = function manageCustomerUpdatSave(params) {
    return _axios2.default.post('/manage/customer/update', params).then(function (res) {
        return res.data;
    });
};

var inquiryUpdateType = exports.inquiryUpdateType = function inquiryUpdateType(params) {
    return _axios2.default.post('/inquiry/update/type', params).then(function (res) {
        return res.data;
    });
};
var inquiryUpdateState = exports.inquiryUpdateState = function inquiryUpdateState(params) {
    return _axios2.default.post('/inquiry/update/state', params).then(function (res) {
        return res.data;
    });
};
var inquiryUpdateRenew = exports.inquiryUpdateRenew = function inquiryUpdateRenew(params) {
    return _axios2.default.post('/inquiry/update/type/renew', params).then(function (res) {
        return res.data;
    });
};
var inquiryUpdateRenewBatch = exports.inquiryUpdateRenewBatch = function inquiryUpdateRenewBatch(params) {
    return _axios2.default.post('/inquiry/batch/update/type/renew', params).then(function (res) {
        return res.data;
    });
};
var GetcompanyList = exports.GetcompanyList = function GetcompanyList(params) {
    return _axios2.default.post('/company/list', params).then(function (res) {
        return res.data;
    });
};
var GetcompanySave = exports.GetcompanySave = function GetcompanySave(params) {
    return _axios2.default.post('/company/save', params).then(function (res) {
        return res.data;
    });
};
var Getcompanydetail = exports.Getcompanydetail = function Getcompanydetail(params) {
    return _axios2.default.post('/company/detail', params).then(function (res) {
        return res.data;
    });
};
var GetcompanyUpdate = exports.GetcompanyUpdate = function GetcompanyUpdate(params) {
    return _axios2.default.post('/company/update', params).then(function (res) {
        return res.data;
    });
};
var GetcompanyDel = exports.GetcompanyDel = function GetcompanyDel(params) {
    return _axios2.default.post('/company/delete', params).then(function (res) {
        return res.data;
    });
};

var GetFinanceList = exports.GetFinanceList = function GetFinanceList(params) {
    return _axios2.default.post('/finance/list', params).then(function (res) {
        return res.data;
    });
};
var GetFinanceListForeign = exports.GetFinanceListForeign = function GetFinanceListForeign(params) {
    return _axios2.default.post('/foreign/finance/list', params).then(function (res) {
        return res.data;
    });
};
var updateFinance = exports.updateFinance = function updateFinance(params) {
    return _axios2.default.post('/finance/update', params).then(function (res) {
        return res.data;
    });
};
var batchUpdateFinance = exports.batchUpdateFinance = function batchUpdateFinance(params) {
    return _axios2.default.post('/finance/batch/update', params).then(function (res) {
        return res.data;
    });
};
var GetFinanceDetail = exports.GetFinanceDetail = function GetFinanceDetail(params) {
    return _axios2.default.post('/finance/detail', params).then(function (res) {
        return res.data;
    });
};
var GetinvoiceList = exports.GetinvoiceList = function GetinvoiceList(params) {
    return _axios2.default.post('/invoice/list', params).then(function (res) {
        return res.data;
    });
};
var GetinvoiceListForeign = exports.GetinvoiceListForeign = function GetinvoiceListForeign(params) {
    return _axios2.default.post('/foreign/invoice/list', params).then(function (res) {
        return res.data;
    });
};
var GetinvoiceDetail = exports.GetinvoiceDetail = function GetinvoiceDetail(params) {
    return _axios2.default.post('/invoice/detail', params).then(function (res) {
        return res.data;
    });
};
var GetinvoiceDetailForeign = exports.GetinvoiceDetailForeign = function GetinvoiceDetailForeign(params) {
    return _axios2.default.post('/foreign/invoice/detail', params).then(function (res) {
        return res.data;
    });
};
var Getinvoiceoperate = exports.Getinvoiceoperate = function Getinvoiceoperate(params) {
    return _axios2.default.post('/invoice/operate', params).then(function (res) {
        return res.data;
    });
};
var payPolicyList = exports.payPolicyList = function payPolicyList(params) {
    return _axios2.default.post('/pay/policy/list', params).then(function (res) {
        return res.data;
    });
};
var findClaimUnpaidList = exports.findClaimUnpaidList = function findClaimUnpaidList(params) {
    return _axios2.default.post('/pay/policy/findClaimUnpaidList', params).then(function (res) {
        return res.data;
    });
};
var payPolicyListForeign = exports.payPolicyListForeign = function payPolicyListForeign(params) {
    return _axios2.default.post('/foreign/pay/policy/list', params).then(function (res) {
        return res.data;
    });
};
var payPolicyDetail = exports.payPolicyDetail = function payPolicyDetail(params) {
    return _axios2.default.post('/pay/policy/detail', params).then(function (res) {
        return res.data;
    });
};
var claimUnpaidDetail = exports.claimUnpaidDetail = function claimUnpaidDetail(params) {
    return _axios2.default.post('/pay/policy/claimUnpaidDetail', params).then(function (res) {
        return res.data;
    });
};

var payPolicyupdate = exports.payPolicyupdate = function payPolicyupdate(params) {
    return _axios2.default.post('/pay/policy/update', params).then(function (res) {
        return res.data;
    });
};
var payPolicyupdateFiled = exports.payPolicyupdateFiled = function payPolicyupdateFiled(params) {
    return _axios2.default.post('/pay/policy/update/all', params).then(function (res) {
        return res.data;
    });
};
var notifyClientBatchUpdate = exports.notifyClientBatchUpdate = function notifyClientBatchUpdate(params) {
    return _axios2.default.post('/pay/policy/update/informCustomer', params).then(function (res) {
        return res.data;
    });
};
var invoiceExcel = exports.invoiceExcel = function invoiceExcel(params) {
    return _axios2.default.post('/invoice/create/excel', params, { responseType: 'blob' }).then(function (res) {
        return res.data;
    });
};
var policyExcel = exports.policyExcel = function policyExcel(params) {
    return _axios2.default.post('/pay/policy/create/excel', params, { responseType: 'blob' }).then(function (res) {
        return res.data;
    });
};
var policyExcelForeign = exports.policyExcelForeign = function policyExcelForeign(params) {
    return _axios2.default.post('/foreign/pay/policy/create/excel', params, { responseType: 'blob' }).then(function (res) {
        return res.data;
    });
};

var queryUnderwriteStatistics = exports.queryUnderwriteStatistics = function queryUnderwriteStatistics(params) {
    return _axios2.default.post('/policy/main/queryUnderwriteStatistics', params).then(function (res) {
        return res.data;
    });
};
var queryClaimStatistics = exports.queryClaimStatistics = function queryClaimStatistics(params) {
    return _axios2.default.post('/policy/claim/queryClaimStatistics', params).then(function (res) {
        return res.data;
    });
};

var queryListByPage = exports.queryListByPage = function queryListByPage(params) {
    return _axios2.default.post('/policy/main/queryListByPage', params).then(function (res) {
        return res.data;
    });
};
var policymainSave = exports.policymainSave = function policymainSave(params) {
    return _axios2.default.post('/policy/main/save', params).then(function (res) {
        return res.data;
    });
};
var policyqueryDetail = exports.policyqueryDetail = function policyqueryDetail(params) {
    return _axios2.default.post('/policy/main/queryDetail', params).then(function (res) {
        return res.data;
    });
};
var policyqueryUpdate = exports.policyqueryUpdate = function policyqueryUpdate(params) {
    return _axios2.default.post('/policy/main/update', params).then(function (res) {
        return res.data;
    });
};
var policyquerydelete = exports.policyquerydelete = function policyquerydelete(params) {
    return _axios2.default.post('/policy/main/delete', params).then(function (res) {
        return res.data;
    });
};
var policyQueryListByPage = exports.policyQueryListByPage = function policyQueryListByPage(params) {
    return _axios2.default.post('/pay/policy/queryListByPage', params).then(function (res) {
        return res.data;
    });
};
var checkPolicyNoExists = exports.checkPolicyNoExists = function checkPolicyNoExists(params) {
    return _axios2.default.post('/policy/main/checkPolicyNoExists', params).then(function (res) {
        return res.data;
    });
};

var paypolicyqueryDetail = exports.paypolicyqueryDetail = function paypolicyqueryDetail(params) {
    return _axios2.default.post('/pay/policy/queryDetail', params).then(function (res) {
        return res.data;
    });
};
var policymainCorrect = exports.policymainCorrect = function policymainCorrect(params) {
    return _axios2.default.post('/policy/main/correct', params).then(function (res) {
        return res.data;
    });
};
var policymainCorrectEdit = exports.policymainCorrectEdit = function policymainCorrectEdit(params) {
    return _axios2.default.post('/policy/main/correctUpdate', params).then(function (res) {
        return res.data;
    });
};
var policyReneListByPage = exports.policyReneListByPage = function policyReneListByPage(params) {
    return _axios2.default.post('/policy/renew/queryListByPage', params).then(function (res) {
        return res.data;
    });
};
var policyRenewdistribute = exports.policyRenewdistribute = function policyRenewdistribute(params) {
    return _axios2.default.post('/policy/renew/distribute', params).then(function (res) {
        return res.data;
    });
};
var policyRenewLostback = exports.policyRenewLostback = function policyRenewLostback(params) {
    return _axios2.default.post('/policy/renew/lostBack', params).then(function (res) {
        return res.data;
    });
};
var distributionBatchRequest = exports.distributionBatchRequest = function distributionBatchRequest(params) {
    return _axios2.default.post('/policy/renew/distributeBatch', params).then(function (res) {
        return res.data;
    });
};
var queryUserListOfRole = exports.queryUserListOfRole = function queryUserListOfRole(params) {
    return _axios2.default.get('/staff/sysStaff/queryUserListOfRole?roleCode=' + params).then(function (res) {
        return res.data;
    });
};
var getAllcompany = exports.getAllcompany = function getAllcompany(params) {
    return _axios2.default.post('/company/list/all', params).then(function (res) {
        return res.data;
    });
};
var manageCustomerRemark = exports.manageCustomerRemark = function manageCustomerRemark(params) {
    return _axios2.default.post('/manage/customer/remark', params).then(function (res) {
        return res.data;
    });
};
var payPolicyAduit = exports.payPolicyAduit = function payPolicyAduit(params) {
    return _axios2.default.post('/pay/policy/aduit', params).then(function (res) {
        return res.data;
    });
};

var getMenuList = exports.getMenuList = function getMenuList(params) {
    return _axios2.default.post('/menuManagers/sysMenu/getMenuList', params).then(function (res) {
        return res.data;
    });
};

var fileDownload = exports.fileDownload = function fileDownload(params) {
    return _axios2.default.get('/file/download?attachmentId=' + params, { responseType: 'blob' }).then(function (res) {
        return res.data;
    });
};
var inquirySave = exports.inquirySave = function inquirySave(params) {
    return _axios2.default.post('/inquiry/save', params).then(function (res) {
        return res.data;
    });
};
var inquiryWorkerList = exports.inquiryWorkerList = function inquiryWorkerList(params) {
    return _axios2.default.post('/inquiry/worker/list', params).then(function (res) {
        return res.data;
    });
};
var inquiryList = exports.inquiryList = function inquiryList(params) {
    return _axios2.default.post('/inquiry/list', params).then(function (res) {
        return res.data;
    });
};
var inquiryDetail = exports.inquiryDetail = function inquiryDetail(params) {
    return _axios2.default.post('/inquiry/detail', params).then(function (res) {
        return res.data;
    });
};
var inquiryUpdate = exports.inquiryUpdate = function inquiryUpdate(params) {
    return _axios2.default.post('/inquiry/update', params).then(function (res) {
        return res.data;
    });
};
var inquiryUpdateStatus = exports.inquiryUpdateStatus = function inquiryUpdateStatus(params) {
    return _axios2.default.post('/inquiry/update/status', params).then(function (res) {
        return res.data;
    });
};
var turnToEnquiry = exports.turnToEnquiry = function turnToEnquiry(params) {
    return _axios2.default.post('/inquiry/update/status', params).then(function (res) {
        return res.data;
    });
};
var inquiryWorker = exports.inquiryWorker = function inquiryWorker(params) {
    return _axios2.default.post('/inquiry/worker', params).then(function (res) {
        return res.data;
    });
};
var inquiryfollowAdd = exports.inquiryfollowAdd = function inquiryfollowAdd(params) {
    return _axios2.default.post('/inquiry/follow/add', params).then(function (res) {
        return res.data;
    });
};

var userAdd = exports.userAdd = function userAdd(params) {
    return _axios2.default.post('/userInfo/userAdd', params, { responseType: 'blob' }).then(function (res) {
        return res;
    }).catch(function (res) {
        return res;
    });
};
var userSave = exports.userSave = function userSave(params) {
    return _axios2.default.post('/staff/sysStaff/save', params).then(function (res) {
        return res;
    }).catch(function (res) {
        return res;
    });
};

var userReset = exports.userReset = function userReset(params) {
    return _axios2.default.post('/staff/sysStaff/reset', params).then(function (res) {
        return res;
    }).catch(function (res) {
        return res;
    });
};

var userUpdate = exports.userUpdate = function userUpdate(params) {
    return _axios2.default.post('/staff/sysStaff/update', params).then(function (res) {
        return res;
    }).catch(function (res) {
        return res;
    });
};

var batchRemoveUser = exports.batchRemoveUser = function batchRemoveUser(params) {
    return _axios2.default.post('/staff/sysStaff/delete', params, { headers: { 'Content-Type': 'application/json;charset=utf-8' } }).then(function (res) {
        return res;
    }).catch(function (res) {
        return res;
    });
};

var userQuery = exports.userQuery = function userQuery(params) {
    return _axios2.default.post('/staff/sysStaff/query', params).then(function (res) {
        return res;
    }).catch(function (res) {
        return res;
    });
};

var headerPic = exports.headerPic = function headerPic(params) {
    return _axios2.default.post('/userInfo/fileUpload', params, { responseType: 'blob' }).then(function (res) {
        return res;
    }).catch(function (res) {
        return res;
    });
};
var roleSave = exports.roleSave = function roleSave(params) {
    return _axios2.default.post('/rolemanager/sysRole/save', params).then(function (res) {
        return res;
    }).catch(function (res) {
        return res;
    });
};

var roleUpdate = exports.roleUpdate = function roleUpdate(params) {
    return _axios2.default.post('/rolemanager/sysRole/update', params).then(function (res) {
        return res;
    }).catch(function (res) {
        return res;
    });
};

var batchRemoveRole = exports.batchRemoveRole = function batchRemoveRole(params) {
    return _axios2.default.post('/rolemanager/sysRole/delete', params, { headers: { 'Content-Type': 'application/json;charset=utf-8' } }).then(function (res) {
        return res;
    }).catch(function (res) {
        return res;
    });
};

var roleQuery = exports.roleQuery = function roleQuery(params) {
    return _axios2.default.post('/rolemanager/sysRole/queryWithCondition', params).then(function (res) {
        return res;
    }).catch(function (res) {
        return res;
    });
};

var roleQueryRoleList = exports.roleQueryRoleList = function roleQueryRoleList(params) {
    return _axios2.default.post('/rolemanager/sysRole/queryAllRole').then(function (res) {
        return res;
    }).catch(function (res) {
        return res;
    });
};
var roleQueryAll = exports.roleQueryAll = function roleQueryAll(params) {
    return _axios2.default.post('/rolemanager/sysRole/queryUserRole', params).then(function (res) {
        return res;
    }).catch(function (res) {
        return res;
    });
};

var userRoleAlloc = exports.userRoleAlloc = function userRoleAlloc(params) {
    return _axios2.default.post('/rolemanager/sysRole/userRoleAlloc', params, { headers: { 'Content-Type': 'application/json;charset=utf-8' } }).then(function (res) {
        return res;
    }).catch(function (res) {
        return res;
    });
};
var menuSave = exports.menuSave = function menuSave(params) {
    return _axios2.default.post('/menuManagers/sysMenu/save', params).then(function (res) {
        return res;
    }).catch(function (res) {
        return res;
    });
};

var menuUpdate = exports.menuUpdate = function menuUpdate(params) {
    return _axios2.default.post('/menuManagers/sysMenu/update', params).then(function (res) {
        return res;
    }).catch(function (res) {
        return res;
    });
};

var batchRemoveMenu = exports.batchRemoveMenu = function batchRemoveMenu(params) {
    return _axios2.default.post('/menuManagers/sysMenu/delete', params, { headers: { 'Content-Type': 'application/json;charset=utf-8' } }).then(function (res) {
        return res;
    }).catch(function (res) {
        return res;
    });
};

var menuQuery = exports.menuQuery = function menuQuery(params) {
    return _axios2.default.post('/menuManagers/sysMenu/query', params).then(function (res) {
        return res;
    }).catch(function (res) {
        return res;
    });
};
var menuList = exports.menuList = function menuList(params) {
    return _axios2.default.post('/menuManagers/sysMenu/menuList').then(function (res) {
        return res;
    }).catch(function (res) {
        return res;
    });
};
var menuListOfData = exports.menuListOfData = function menuListOfData(params) {
    return _axios2.default.post('/menuManagers/sysMenu/menuListOfData').then(function (res) {
        return res;
    }).catch(function (res) {
        return res;
    });
};

var menuQueryAll = exports.menuQueryAll = function menuQueryAll(params) {
    return _axios2.default.post('/menuManagers/sysMenu/queryRoleMenu', params).then(function (res) {
        return res;
    }).catch(function (res) {
        return res;
    });
};
var queryRoleAllocMenu = exports.queryRoleAllocMenu = function queryRoleAllocMenu(params) {
    return _axios2.default.post('/menuManagers/sysMenu/queryRoleAllocMenu', params).then(function (res) {
        return res;
    }).catch(function (res) {
        return res;
    });
};
var roleMenuAlloc = exports.roleMenuAlloc = function roleMenuAlloc(params) {
    return _axios2.default.post('/menuManagers/sysMenu/roleMenuAlloc', params).then(function (res) {
        return res;
    }).catch(function (res) {
        return res;
    });
};
var getCurrentUserMenuList = exports.getCurrentUserMenuList = function getCurrentUserMenuList(_) {
    return _axios2.default.post('/menuManagers/sysMenu/getMenuList').then(function (res) {
        return res;
    }).catch(function (res) {
        return res;
    });
};
var buttonSave = exports.buttonSave = function buttonSave(params) {
    return _axios2.default.post('/buttonManager/sysButton/save', params).then(function (res) {
        return res;
    }).catch(function (res) {
        return res;
    });
};

var buttonUpdate = exports.buttonUpdate = function buttonUpdate(params) {
    return _axios2.default.post('/buttonManager/sysButton/update', params).then(function (res) {
        return res;
    }).catch(function (res) {
        return res;
    });
};

var batchRemoveButton = exports.batchRemoveButton = function batchRemoveButton(params) {
    return _axios2.default.post('/buttonManager/sysButton/delete', params, { headers: { 'Content-Type': 'application/json;charset=utf-8' } }).then(function (res) {
        return res;
    }).catch(function (res) {
        return res;
    });
};

var menuButtonAlloc = exports.menuButtonAlloc = function menuButtonAlloc(params) {
    return _axios2.default.post('/buttonManager/sysButton/menuButtonAlloc', params, { headers: { 'Content-Type': 'application/json;charset=utf-8' } }).then(function (res) {
        return res;
    }).catch(function (res) {
        return res;
    });
};

var buttonQuery = exports.buttonQuery = function buttonQuery(params) {
    return _axios2.default.post('/buttonManager/sysButton/query', params).then(function (res) {
        return res;
    }).catch(function (res) {
        return res;
    });
};

var buttonQueryAll = exports.buttonQueryAll = function buttonQueryAll(params) {
    return _axios2.default.post('/buttonManager/sysButton/queryMenuButton', params).then(function (res) {
        return res;
    }).catch(function (res) {
        return res;
    });
};

var buttonOfRoleQuery = exports.buttonOfRoleQuery = function buttonOfRoleQuery(params) {
    return _axios2.default.post('/buttonManager/sysButton/queryRoleMenuButton', params).then(function (res) {
        return res;
    }).catch(function (res) {
        return res;
    });
};
var queryRoleMenuButtonAll = exports.queryRoleMenuButtonAll = function queryRoleMenuButtonAll(params) {
    return _axios2.default.post('/buttonManager/sysButton/queryRoleMenuButtonAll', params).then(function (res) {
        return res;
    }).catch(function (res) {
        return res;
    });
};
var roleMenuButtonAlloc = exports.roleMenuButtonAlloc = function roleMenuButtonAlloc(params) {
    return _axios2.default.post('/buttonManager/sysButton/roleMenuButtonAlloc', params, { headers: { 'Content-Type': 'application/json;charset=utf-8' } }).then(function (res) {
        return res;
    }).catch(function (res) {
        return res;
    });
};
var paramGroupAdd = exports.paramGroupAdd = function paramGroupAdd(params) {
    return _axios2.default.post('/paraManager/sysCodeInfo/save', params).then(function (res) {
        return res;
    }).catch(function (res) {
        return res;
    });
};

var batchRemoveParamGroup = exports.batchRemoveParamGroup = function batchRemoveParamGroup(params) {
    return _axios2.default.post('/paraManager/sysCodeInfo/delete', params, { headers: { 'Content-Type': 'application/json;charset=utf-8' } }).then(function (res) {
        return res;
    }).catch(function (res) {
        return res;
    });
};

var paramGroupUpdate = exports.paramGroupUpdate = function paramGroupUpdate(params) {
    return _axios2.default.post('/paraManager/sysCodeInfo/update', params).then(function (res) {
        return res;
    }).catch(function (res) {
        return res;
    });
};

var paramGroupQuery = exports.paramGroupQuery = function paramGroupQuery(params) {
    return _axios2.default.post('/paraManager/sysCodeInfo/query', params).then(function (res) {
        return res;
    }).catch(function (res) {
        return res;
    });
};

var paramGroupQueryByPid = exports.paramGroupQueryByPid = function paramGroupQueryByPid(params) {
    return _axios2.default.post('/paraManager/sysCodeInfo/queryByPid', params).then(function (res) {
        return res;
    }).catch(function (res) {
        return res;
    });
};
var fileSave = exports.fileSave = function fileSave(params) {
    return _axios2.default.post('/content/circular/save', params).then(function (res) {
        return res;
    }).catch(function (res) {
        return res;
    });
};
var questionSave = exports.questionSave = function questionSave(params) {
    return _axios2.default.post('/content/question/save', params).then(function (res) {
        return res;
    }).catch(function (res) {
        return res;
    });
};
var questionDetail = exports.questionDetail = function questionDetail(params) {
    return _axios2.default.post('/content/detail', params).then(function (res) {
        return res;
    }).catch(function (res) {
        return res;
    });
};
var questionAllList = exports.questionAllList = function questionAllList(params) {
    return _axios2.default.post('/content/question/all/list', params).then(function (res) {
        return res;
    }).catch(function (res) {
        return res;
    });
};
var questionDetailWithFeed = exports.questionDetailWithFeed = function questionDetailWithFeed(params) {
    return _axios2.default.post('/content/question/detail', params).then(function (res) {
        return res;
    }).catch(function (res) {
        return res;
    });
};
var fileDetailWithFeed = exports.fileDetailWithFeed = function fileDetailWithFeed(params) {
    return _axios2.default.post("/content/question/detail", params).then(function (res) {
        return res;
    }).catch(function (res) {
        return res;
    });
};
var questionUpdate = exports.questionUpdate = function questionUpdate(params) {
    return _axios2.default.post('/content/question/update', params).then(function (res) {
        return res;
    }).catch(function (res) {
        return res;
    });
};
var fileUpdate = exports.fileUpdate = function fileUpdate(params) {
    return _axios2.default.post('/content/circular/update', params).then(function (res) {
        return res;
    }).catch(function (res) {
        return res;
    });
};
var questionDelete = exports.questionDelete = function questionDelete(params) {
    return _axios2.default.post('/content/delete', params).then(function (res) {
        return res;
    }).catch(function (res) {
        return res;
    });
};
var filePaperDelete = exports.filePaperDelete = function filePaperDelete(params) {
    return _axios2.default.post('/content/delete', params).then(function (res) {
        return res;
    }).catch(function (res) {
        return res;
    });
};
var fileListQuery = exports.fileListQuery = function fileListQuery(params) {
    return _axios2.default.post('/content/circular/list', params).then(function (res) {
        return res;
    }).catch(function (res) {
        return res;
    });
};
var fileUploadListQuery = exports.fileUploadListQuery = function fileUploadListQuery(params) {
    return _axios2.default.post('/content/attachment/list', params).then(function (res) {
        return res;
    }).catch(function (res) {
        return res;
    });
};
var questionQuery = exports.questionQuery = function questionQuery(params) {
    return _axios2.default.post('/content/circular/list', params).then(function (res) {
        return res;
    }).catch(function (res) {
        return res;
    });
};
var questionFeedback = exports.questionFeedback = function questionFeedback(params) {
    return _axios2.default.post('/content/feedback/add', params).then(function (res) {
        return res;
    }).catch(function (res) {
        return res;
    });
};
var caseSave = exports.caseSave = function caseSave(params) {
    return _axios2.default.post('/content/case/save', params).then(function (res) {
        return res;
    }).catch(function (res) {
        return res;
    });
};
var caseDetail = exports.caseDetail = function caseDetail(params) {
    return _axios2.default.post('/content/detail', params).then(function (res) {
        return res;
    }).catch(function (res) {
        return res;
    });
};
var caseDelete = exports.caseDelete = function caseDelete(params) {
    return _axios2.default.post('/content/delete', params).then(function (res) {
        return res;
    }).catch(function (res) {
        return res;
    });
};
var caseQuery = exports.caseQuery = function caseQuery(params) {
    return _axios2.default.post('/content/case/list', params).then(function (res) {
        return res;
    }).catch(function (res) {
        return res;
    });
};
var caseUpdate = exports.caseUpdate = function caseUpdate(params) {
    return _axios2.default.post('/content/case/update', params).then(function (res) {
        return res;
    }).catch(function (res) {
        return res;
    });
};
var noticeSave = exports.noticeSave = function noticeSave(params) {
    return _axios2.default.post('/content/circular/save', params).then(function (res) {
        return res;
    }).catch(function (res) {
        return res;
    });
};
var noticeDetail = exports.noticeDetail = function noticeDetail(params) {
    return _axios2.default.post('/content/detail', params).then(function (res) {
        return res;
    }).catch(function (res) {
        return res;
    });
};
var noticeDelete = exports.noticeDelete = function noticeDelete(params) {
    return _axios2.default.post('/content/delete', params).then(function (res) {
        return res;
    }).catch(function (res) {
        return res;
    });
};
var noticeList = exports.noticeList = function noticeList(params) {
    return _axios2.default.post('/content/circular/list', params).then(function (res) {
        return res;
    }).catch(function (res) {
        return res;
    });
};
var noticeUpdate = exports.noticeUpdate = function noticeUpdate(params) {
    return _axios2.default.post('/content/circular/update', params).then(function (res) {
        return res;
    }).catch(function (res) {
        return res;
    });
};
var getCode = exports.getCode = function getCode(params) {
    return _axios2.default.post('/paraManager/sysCodeInfo/getCode', params).then(function (res) {
        return res;
    }).catch(function (res) {
        return res;
    });
};
var getCrmList = exports.getCrmList = function getCrmList(_) {
    return _axios2.default.post('/crm/customer/all/list').then(function (res) {
        return res;
    }).catch(function (res) {
        return res;
    });
};
var getPage = exports.getPage = function getPage(params) {
    return _axios2.default.post('/policy/claim/query', params).then(function (res) {
        return res;
    }).catch(function (res) {
        return res;
    });
};
var getVisitQuery = exports.getVisitQuery = function getVisitQuery(params) {
    return _axios2.default.post('/policy/claim/visitClaimQuery', params).then(function (res) {
        return res;
    }).catch(function (res) {
        return res;
    });
};
var claimVisitUpdate = exports.claimVisitUpdate = function claimVisitUpdate(params) {
    return _axios2.default.post('/policy/claim/updateVisitSatisLevel', params).then(function (res) {
        return res;
    }).catch(function (res) {
        return res;
    });
};
var claimVisitNeedUpdate = exports.claimVisitNeedUpdate = function claimVisitNeedUpdate(params) {
    return _axios2.default.post('/policy/claim/updateNeedVisit', params).then(function (res) {
        return res;
    }).catch(function (res) {
        return res;
    });
};
var addClaimFollowRecord = exports.addClaimFollowRecord = function addClaimFollowRecord(params) {
    return _axios2.default.post('/policy/claim/addClaimFollowRecord', params).then(function (res) {
        return res;
    }).catch(function (res) {
        return res;
    });
};
var getNoticePage = exports.getNoticePage = function getNoticePage(params) {
    return _axios2.default.post('/policy/claim/noticeList', params).then(function (res) {
        return res;
    }).catch(function (res) {
        return res;
    });
};
var getHis = exports.getHis = function getHis(params) {
    return _axios2.default.post('/policy/main/queryEffectivePolicy', params).then(function (res) {
        return res;
    }).catch(function (res) {
        return res;
    });
};
var saveClaim = exports.saveClaim = function saveClaim(params) {
    return _axios2.default.post('/policy/claim/save', params).then(function (res) {
        return res;
    }).catch(function (res) {
        return res;
    });
};
var updateClaimDetail = exports.updateClaimDetail = function updateClaimDetail(params) {
    return _axios2.default.post('/policy/claim/update', params).then(function (res) {
        return res;
    }).catch(function (res) {
        return res;
    });
};
var updateClaim = exports.updateClaim = function updateClaim(params) {
    return _axios2.default.post('/policy/claim/dispatch', params).then(function (res) {
        return res;
    }).catch(function (res) {
        return res;
    });
};
var claimDetail = exports.claimDetail = function claimDetail(params) {
    return _axios2.default.post('/policy/claim/queryDetail', params).then(function (res) {
        return res;
    }).catch(function (res) {
        return res;
    });
};
var getHisPage = exports.getHisPage = function getHisPage(params) {
    return _axios2.default.post('/policy/claim/queryHistoryCaseList', params).then(function (res) {
        return res;
    }).catch(function (res) {
        return res;
    });
};
var remainderValid = exports.remainderValid = function remainderValid(params) {
    return _axios2.default.post('/claim/checkNotice', params).then(function (res) {
        return res;
    }).catch(function (res) {
        return res;
    });
};
var remainderChange = exports.remainderChange = function remainderChange(params) {
    return _axios2.default.post('/claim/addNotice', params).then(function (res) {
        return res;
    }).catch(function (res) {
        return res;
    });
};
var remainderCancel = exports.remainderCancel = function remainderCancel(params) {
    return _axios2.default.post('/claim/cancelNotice', params).then(function (res) {
        return res;
    }).catch(function (res) {
        return res;
    });
};
var closeCase = exports.closeCase = function closeCase(params) {
    return _axios2.default.post('/policy/claim/closeCase', params).then(function (res) {
        return res;
    }).catch(function (res) {
        return res;
    });
};
var withdraw = exports.withdraw = function withdraw(params) {
    return _axios2.default.post('/policy/claim/withdraw', params).then(function (res) {
        return res;
    }).catch(function (res) {
        return res;
    });
};
var claimAddFileQuery = exports.claimAddFileQuery = function claimAddFileQuery(params) {
    return _axios2.default.post('/attachment/list', params).then(function (res) {
        return res;
    }).catch(function (res) {
        return res;
    });
};
var claimDelete = exports.claimDelete = function claimDelete(params) {
    return _axios2.default.post('/policy/claim/delete', params).then(function (res) {
        return res;
    }).catch(function (res) {
        return res;
    });
};
var jumpToCaseDetail = exports.jumpToCaseDetail = function jumpToCaseDetail(params) {
    var flag = params.$this.$router.options.routes[5].children.some(function (item) {
        return item.path === params.pathName;
    });

    if (!flag) {
        params.$this.$router.options.routes[5].children.push({
            name: params.tageName,
            path: params.pathName,
            component: function component(resolve) {
                return __webpack_require__.e/* require */(8/* duplicate */).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(89)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
            } });
        params.$this.$router.addRoutes(params.$this.$router.options.routes);
        var claimRouteNum = JSON.parse(sessionStorage.getItem("claimRouteNum"));
        if (!claimRouteNum) {
            claimRouteNum = [];
        }
        claimRouteNum.push({
            name: params.tageName,
            path: params.pathName });
        sessionStorage.setItem("claimRouteNum", (0, _stringify2.default)(claimRouteNum));
    }

    params.$this.$router.push({ path: params.pathName, query: params.param });
};

var customerFileQuery = exports.customerFileQuery = function customerFileQuery(params) {
    return _axios2.default.post('/attachment/getCustomerAttachments', params).then(function (res) {
        return res;
    }).catch(function (res) {
        return res;
    });
};
var fileQuery = exports.fileQuery = function fileQuery(params) {
    return _axios2.default.post('/attachment/queryList', params).then(function (res) {
        return res;
    }).catch(function (res) {
        return res;
    });
};
var fileDelete = exports.fileDelete = function fileDelete(params) {
    return _axios2.default.get('/file/delete' + params).then(function (res) {
        return res;
    }).catch(function (res) {
        return res;
    });
};
var fileDownloadPost = exports.fileDownloadPost = function fileDownloadPost(params) {
    return _axios2.default.post('/file/generateZip', params).then(function (res) {
        if (res.data.success) {
            var zipId = res.data.data["id"];
            var ctx = "https://huayang-in.com/HYIECB-v1.0";
            var access_token = _vueCookies2.default.get('access_token');
            var circleUrl = "";

            if (access_token && access_token.length > 0) {
                circleUrl = ctx + "/file/downloadZip?id=" + zipId + "&Authorization=" + access_token;

                var a = document.createElement("a");
                a.style.display = "none";
                a.setAttribute("href", circleUrl);
                document.body.appendChild(a);
                a.click();
            }
        }
    }).catch(function (res) {
        return res;
    });
};

var insurancesubjectAdd = exports.insurancesubjectAdd = function insurancesubjectAdd(params) {
    return _axios2.default.post('/insurancesubject/add', params).then(function (res) {
        return res.data;
    }).catch(function (res) {
        return res.data;
    });
};
var insurancesubjectDelete = exports.insurancesubjectDelete = function insurancesubjectDelete(params) {
    return _axios2.default.post('/insurancesubject/delete', params).then(function (res) {
        return res.data;
    }).catch(function (res) {
        return res.data;
    });
};
var insurancesubjectUpdate = exports.insurancesubjectUpdate = function insurancesubjectUpdate(params) {
    return _axios2.default.post('/insurancesubject/update', params).then(function (res) {
        return res.data;
    }).catch(function (res) {
        return res.data;
    });
};

var financialQuery = exports.financialQuery = function financialQuery(params) {
    return _axios2.default.get('/inquiry/cw/first').then(function (res) {
        return res.data;
    });
};
var payPolicyListHomepage = exports.payPolicyListHomepage = function payPolicyListHomepage(params) {
    return _axios2.default.post('/pay/policy/cw/first/pay/list', params).then(function (res) {
        return res.data;
    });
};
var invoiceListHomepage = exports.invoiceListHomepage = function invoiceListHomepage(params) {
    return _axios2.default.post('/invoice/cw/first/invoice/list', params).then(function (res) {
        return res.data;
    });
};
var underWritingQuery = exports.underWritingQuery = function underWritingQuery(params) {
    return _axios2.default.get('/inquiry/hby/first').then(function (res) {
        return res.data;
    });
};
var policyQuery = exports.policyQuery = function policyQuery(params) {
    return _axios2.default.post('/inquiry/cdy/first', params).then(function (res) {
        return res.data;
    });
};
var claimHomeQuery = exports.claimHomeQuery = function claimHomeQuery(params) {
    return _axios2.default.post('/claim/homepage/user/overview', params).then(function (res) {
        return res.data;
    });
};
var CHMProcessingQuery = exports.CHMProcessingQuery = function CHMProcessingQuery(params) {
    return _axios2.default.post('/claim/homepage/manager/overview', params).then(function (res) {
        return res.data;
    });
};
var CHMCountViewQuery = exports.CHMCountViewQuery = function CHMCountViewQuery(params) {
    return _axios2.default.get('/claim/homepage/manager/statistics').then(function (res) {
        return res.data;
    });
};

var turnToEnquiryPost = exports.turnToEnquiryPost = function turnToEnquiryPost(params) {
    return _axios2.default.post('/policy/renew/addManualRenew', params).then(function (res) {
        return res.data;
    });
};
var claimUserList = exports.claimUserList = function claimUserList(params) {
    return _axios2.default.post('/claim/homepage/user/overview/list', params).then(function (res) {
        return res.data;
    });
};
var claimManagerList = exports.claimManagerList = function claimManagerList(params) {
    return _axios2.default.post('/claim/homepage/manager/overview/list', params).then(function (res) {
        return res.data;
    });
};
var claimManagerStatisticsList = exports.claimManagerStatisticsList = function claimManagerStatisticsList(params) {
    return _axios2.default.post('/claim/homepage/manager/statistics/list', params).then(function (res) {
        return res.data;
    });
};
var queryWillPolicyList = exports.queryWillPolicyList = function queryWillPolicyList(params) {
    return _axios2.default.post('/inquiry/cdy/first/inquiry/list', params).then(function (res) {
        return res.data;
    });
};
var queryPolicyList = exports.queryPolicyList = function queryPolicyList(params) {
    return _axios2.default.post('/inquiry/cdy/first/list', params).then(function (res) {
        return res.data;
    });
};
var queryAuditPolicyList = exports.queryAuditPolicyList = function queryAuditPolicyList(params) {
    return _axios2.default.post('/inquiry/hby/first/policy/list', params).then(function (res) {
        return res.data;
    });
};
var queryAuditAskPolicyList = exports.queryAuditAskPolicyList = function queryAuditAskPolicyList(params) {
    return _axios2.default.post('/inquiry/hby/first/inquiry/list', params).then(function (res) {
        return res.data;
    });
};
var manualLost = exports.manualLost = function manualLost(params) {
    return _axios2.default.post('/policy/renew/addManualLost', params).then(function (res) {
        return res.data;
    });
};
var inquiryManualLost = exports.inquiryManualLost = function inquiryManualLost(params) {
    return _axios2.default.post('/inquiry/batch/loss', params).then(function (res) {
        return res.data;
    });
};
var inquiryManualNewPolicy = exports.inquiryManualNewPolicy = function inquiryManualNewPolicy(params) {
    return _axios2.default.post('/inquiry/update/batch/state', params).then(function (res) {
        return res.data;
    });
};
var customerAllList = exports.customerAllList = function customerAllList(params) {
    return _axios2.default.post('/crm/customer/all/list', params).then(function (res) {
        return res.data;
    });
};
var policyDetailInfo = exports.policyDetailInfo = function policyDetailInfo(params) {
    return _axios2.default.post('/inquiry/policy/detail', params).then(function (res) {
        return res.data;
    });
};
var filePaperUpload = exports.filePaperUpload = function filePaperUpload(params) {
    return _axios2.default.post('/content/attachment/save', params).then(function (res) {
        return res.data;
    });
};
var groupOfRoleList = exports.groupOfRoleList = function groupOfRoleList(params) {
    return _axios2.default.post('/inquiry/hby/first/detail', params).then(function (res) {
        return res.data;
    });
};
var lossWarrant = exports.lossWarrant = function lossWarrant(params) {
    return _axios2.default.post('/policy/main/loss', params).then(function (res) {
        return res.data;
    });
};
var changeSubjectName = exports.changeSubjectName = function changeSubjectName(params) {
    return _axios2.default.post('/manage/customer/update/insuranceSubject', params).then(function (res) {
        return res.data;
    });
};
var companyAchCount = exports.companyAchCount = function companyAchCount(params) {
    return _axios2.default.post('/census/company/year/count', params).then(function (res) {
        return res.data;
    });
};
var companyAchTargetSave = exports.companyAchTargetSave = function companyAchTargetSave(params) {
    return _axios2.default.post('/census/save', params).then(function (res) {
        return res.data;
    });
};
var companyAchTargetQuery = exports.companyAchTargetQuery = function companyAchTargetQuery(params) {
    return _axios2.default.post('/census/company/rate', params).then(function (res) {
        return res.data;
    });
};
var signAchQuery = exports.signAchQuery = function signAchQuery(params) {
    return _axios2.default.post('/census/sign/rate', params).then(function (res) {
        return res.data;
    });
};
var sellerAchTargetQuery = exports.sellerAchTargetQuery = function sellerAchTargetQuery(params) {
    return _axios2.default.post('/census/seller/year/rate', params).then(function (res) {
        return res.data;
    });
};
var censusSignList = exports.censusSignList = function censusSignList(params) {
    return _axios2.default.post('/census/sign/list', params).then(function (res) {
        return res.data;
    });
};
var renewPolicyDelete = exports.renewPolicyDelete = function renewPolicyDelete(params) {
    return _axios2.default.post('/policy/renew/delete', params).then(function (res) {
        return res.data;
    });
};
var inquiryDiscard = exports.inquiryDiscard = function inquiryDiscard(params) {
    return _axios2.default.post('/inquiry/discard', params).then(function (res) {
        return res.data;
    });
};
var queryClaimList = exports.queryClaimList = function queryClaimList(params) {
    return _axios2.default.post('/policy/main/queryClaimList', params).then(function (res) {
        return res.data;
    });
};
var checkInsuranceSubjectState = exports.checkInsuranceSubjectState = function checkInsuranceSubjectState(params) {
    return _axios2.default.post('/inquiry/check/insuranceSubject', params).then(function (res) {
        return res.data;
    });
};
var insurancesubjectDetail = exports.insurancesubjectDetail = function insurancesubjectDetail(params) {
    return _axios2.default.post('/insurancesubject/detail', params).then(function (res) {
        return res.data;
    });
};
var insurancesubjectContentSave = exports.insurancesubjectContentSave = function insurancesubjectContentSave(params) {
    return _axios2.default.post('/insurancesubject/update/content', params).then(function (res) {
        return res.data;
    });
};
var affiliatedCompanyAdd = exports.affiliatedCompanyAdd = function affiliatedCompanyAdd(params) {
    return _axios2.default.post('/insurancesubject/customer/add', params).then(function (res) {
        return res.data;
    });
};
var affiliatedCompanyDelete = exports.affiliatedCompanyDelete = function affiliatedCompanyDelete(params) {
    return _axios2.default.post('/insurancesubject/customer/delete', params).then(function (res) {
        return res.data;
    });
};
var compensationSituationQuery = exports.compensationSituationQuery = function compensationSituationQuery(params) {
    return _axios2.default.post('/crm/customer/claim/list', params).then(function (res) {
        return res.data;
    });
};
var compensationSituationCountQuery = exports.compensationSituationCountQuery = function compensationSituationCountQuery(params) {
    return _axios2.default.post('/crm/customer/claim/rate', params).then(function (res) {
        return res.data;
    });
};
var queryInquiredList = exports.queryInquiredList = function queryInquiredList(params) {
    return _axios2.default.post('/insurancesubject/all/insuranceType', params).then(function (res) {
        return res.data;
    });
};
var addSubjectFollowUpOperate = exports.addSubjectFollowUpOperate = function addSubjectFollowUpOperate(params) {
    return _axios2.default.post('/insurancesubject/follow/add', params).then(function (res) {
        return res.data;
    });
};
var querySubjectFollowUpList = exports.querySubjectFollowUpList = function querySubjectFollowUpList(params) {
    return _axios2.default.post('/insurancesubject/follow/list', params).then(function (res) {
        return res.data;
    });
};
var updateStaffPassword = exports.updateStaffPassword = function updateStaffPassword(params) {
    return _axios2.default.post('/staff/sysStaff/updatePass', params).then(function (res) {
        return res.data;
    });
};
var customerUpdatePoint = exports.customerUpdatePoint = function customerUpdatePoint(params) {
    return _axios2.default.post('/manage/customer/update/point', params).then(function (res) {
        return res.data;
    });
};
var customerNameChange = exports.customerNameChange = function customerNameChange(params) {
    return _axios2.default.post('/manage/customer/update/name', params).then(function (res) {
        return res.data;
    });
};
var customerSellerChange = exports.customerSellerChange = function customerSellerChange(params) {
    return _axios2.default.post('/manage/customer/update/seller', params).then(function (res) {
        return res.data;
    });
};
var shipNameChange = exports.shipNameChange = function shipNameChange(params) {
    return _axios2.default.post('/manage/customer/update/subject/name', params).then(function (res) {
        return res.data;
    });
};
var commissionStatistics = exports.commissionStatistics = function commissionStatistics(params) {
    return _axios2.default.post('/invoice/commission/statistics', params).then(function (res) {
        return res.data;
    });
};
var commissionStatisticsList = exports.commissionStatisticsList = function commissionStatisticsList(params) {
    return _axios2.default.post('/invoice/commission/statistics/detailList', params).then(function (res) {
        return res.data;
    });
};
var batchModificationOfCommissionRate = exports.batchModificationOfCommissionRate = function batchModificationOfCommissionRate(params) {
    return _axios2.default.post('/foreign/pay/policy/batch/updateYongjinRate', params).then(function (res) {
        return res.data;
    });
};
var queryPremiumBrokerageRatio = exports.queryPremiumBrokerageRatio = function queryPremiumBrokerageRatio(params) {
    return _axios2.default.post('/foreign/pay/policy/premiumBrokerageRatio', params).then(function (res) {
        return res.data;
    });
};
var changeOfTheSubjectVestedCustomer = exports.changeOfTheSubjectVestedCustomer = function changeOfTheSubjectVestedCustomer(params) {
    return _axios2.default.post('/manage/update/subject/customer', params).then(function (res) {
        return res.data;
    });
};
var claimQuerySum = exports.claimQuerySum = function claimQuerySum(params) {
    return _axios2.default.post('/policy/claim/query/sum', params).then(function (res) {
        return res.data;
    });
};

var contactRemarkBatchUpdate = exports.contactRemarkBatchUpdate = function contactRemarkBatchUpdate(params) {
    return _axios2.default.post('/contact/remark/batchUpdate', params).then(function (res) {
        return res.data;
    });
};
var contactRemarkQuery = exports.contactRemarkQuery = function contactRemarkQuery(params) {
    return _axios2.default.post('/contact/remark/contact', params).then(function (res) {
        return res.data;
    });
};
var updateInquiryToWait = exports.updateInquiryToWait = function updateInquiryToWait(params) {
    return _axios2.default.post('/inquiry/update/wait', params).then(function (res) {
        return res.data;
    });
};

var getUrgentList = exports.getUrgentList = function getUrgentList(params) {
    return _axios2.default.post('/policy/claim/urge/query', params).then(function (res) {
        return res.data;
    });
};
var updateUrgentState = exports.updateUrgentState = function updateUrgentState(params) {
    return _axios2.default.post('/policy/claim/add/urge', params).then(function (res) {
        return res.data;
    });
};
var updateUrgentFollow = exports.updateUrgentFollow = function updateUrgentFollow(params) {
    return _axios2.default.post('/policy/claim/add/follow', params).then(function (res) {
        return res.data;
    });
};
var userBan = exports.userBan = function userBan(params) {
    return _axios2.default.post('/staff/sysStaff/ban', params).then(function (res) {
        return res.data;
    });
};
var userUnban = exports.userUnban = function userUnban(params) {
    return _axios2.default.post('/staff/sysStaff/unban', params).then(function (res) {
        return res.data;
    });
};
var addCommCompany = exports.addCommCompany = function addCommCompany(params) {
    return _axios2.default.post('/commCompany/add', params).then(function (res) {
        return res.data;
    });
};
var queryCommCompanyList = exports.queryCommCompanyList = function queryCommCompanyList(params) {
    return _axios2.default.post('/commCompany/list', params).then(function (res) {
        return res.data;
    });
};
var updateCommCompany = exports.updateCommCompany = function updateCommCompany(params) {
    return _axios2.default.post('/commCompany/update', params).then(function (res) {
        return res.data;
    });
};
var deleteCommCompany = exports.deleteCommCompany = function deleteCommCompany(params) {
    return _axios2.default.post('/commCompany/delete', params).then(function (res) {
        return res.data;
    });
};
var setFirstCommCompany = exports.setFirstCommCompany = function setFirstCommCompany(params) {
    return _axios2.default.post('/commCompany/setfirst', params).then(function (res) {
        return res.data;
    });
};

/***/ }),

/***/ 265:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 266:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 267:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 268:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 269:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 270:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 271:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 272:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 273:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 274:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 371:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/u457.e2e0768.jpg";

/***/ }),

/***/ 372:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/u459.49410ac.jpg";

/***/ }),

/***/ 373:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 375:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(268)

var Component = __webpack_require__(11)(
  /* script */
  __webpack_require__(195),
  /* template */
  __webpack_require__(385),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 376:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(269)

var Component = __webpack_require__(11)(
  /* script */
  __webpack_require__(196),
  /* template */
  __webpack_require__(386),
  /* scopeId */
  "data-v-45a876d5",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 377:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(270)

var Component = __webpack_require__(11)(
  /* script */
  __webpack_require__(198),
  /* template */
  __webpack_require__(387),
  /* scopeId */
  "data-v-55cf88fb",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 378:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(267)

var Component = __webpack_require__(11)(
  /* script */
  __webpack_require__(199),
  /* template */
  __webpack_require__(384),
  /* scopeId */
  "data-v-2ae77f68",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 379:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(274)

var Component = __webpack_require__(11)(
  /* script */
  __webpack_require__(200),
  /* template */
  __webpack_require__(390),
  /* scopeId */
  "data-v-f63ea068",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 380:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(273)
__webpack_require__(272)

var Component = __webpack_require__(11)(
  /* script */
  __webpack_require__(201),
  /* template */
  __webpack_require__(389),
  /* scopeId */
  "data-v-93856fd6",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 381:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(265)

var Component = __webpack_require__(11)(
  /* script */
  __webpack_require__(202),
  /* template */
  __webpack_require__(382),
  /* scopeId */
  "data-v-027dd508",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 382:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    directives: [{
      name: "dialogDrag",
      rawName: "v-dialogDrag"
    }],
    key: "UU-PW",
    attrs: {
      "title": "修改密码",
      "visible": _vm.visible,
      "width": "50%",
      "modal": false,
      "center": "",
      "before-close": _vm.handleClose
    },
    on: {
      "update:visible": function($event) {
        _vm.visible = $event
      }
    }
  }, [_c('el-form', {
    attrs: {
      "inline": false,
      "model": _vm.dataObject,
      "label-width": "140px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "原始密码"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password"
    },
    model: {
      value: (_vm.dataObject.oldPassword),
      callback: function($$v) {
        _vm.$set(_vm.dataObject, "oldPassword", $$v)
      },
      expression: "dataObject.oldPassword"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "新密码"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password"
    },
    model: {
      value: (_vm.dataObject.newPassWord),
      callback: function($$v) {
        _vm.$set(_vm.dataObject, "newPassWord", $$v)
      },
      expression: "dataObject.newPassWord"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "确认密码"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password"
    },
    model: {
      value: (_vm.dataObject.checkNewPassWord),
      callback: function($$v) {
        _vm.$set(_vm.dataObject, "checkNewPassWord", $$v)
      },
      expression: "dataObject.checkNewPassWord"
    }
  })], 1)], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.update
    }
  }, [_vm._v("修  改")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": _vm.handleClose
    }
  }, [_vm._v("返  回")])], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 383:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    directives: [{
      name: "dialogDrag",
      rawName: "v-dialogDrag"
    }],
    ref: "reLogin",
    attrs: {
      "id": "reLogin",
      "title": "账号登录",
      "visible": _vm.reLoginDialogVisible,
      "width": "30%",
      "modal": false,
      "center": ""
    },
    on: {
      "update:visible": function($event) {
        _vm.reLoginDialogVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "loginForm",
    attrs: {
      "model": _vm.loginData,
      "rules": _vm.loginRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "username",
      "label": "账号"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "auto-complete": "off",
      "placeholder": "请输入账号"
    },
    model: {
      value: (_vm.loginData.username),
      callback: function($$v) {
        _vm.$set(_vm.loginData, "username", $$v)
      },
      expression: "loginData.username"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "密码",
      "prop": "password"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password",
      "auto-complete": "off",
      "placeholder": "请输入密码"
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.startLogin('loginForm')
      }
    },
    model: {
      value: (_vm.loginData.password),
      callback: function($$v) {
        _vm.$set(_vm.loginData, "password", $$v)
      },
      expression: "loginData.password"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "width": "100%",
      "text-align": "center"
    }
  }, [_c('el-button', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.startLogin('loginForm')
      }
    }
  }, [_vm._v("登录")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 384:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-row', {
    staticClass: "container"
  }, [_c('el-col', {
    staticClass: "header",
    attrs: {
      "span": 24
    }
  }, [(_vm.collapsed) ? _c('el-col', {
    staticClass: "logo",
    class: 'logo-collapse-width',
    attrs: {
      "span": 10
    }
  }, [_vm._v(_vm._s(_vm.sysNameShort))]) : _vm._e(), _vm._v(" "), _c('el-col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.menuShow),
      expression: "menuShow"
    }],
    staticClass: "logo",
    class: 'logo-width',
    attrs: {
      "span": 12
    }
  }, [_c('div', {
    staticClass: "headerinfo"
  }, [_c('span', {
    staticClass: "el-dropdown-link userinfo-inner"
  }, [_c('img', {
    staticStyle: {
      "float": "left",
      "margin-left": "52px",
      "width": "113px",
      "height": "64px",
      "margin-top": "20px"
    },
    attrs: {
      "src": this.headerImg
    }
  })])]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.titleLogo),
      expression: "titleLogo"
    }],
    staticClass: "jnjhead"
  }, [_vm._v("上海华洋保险经纪")])]), _vm._v(" "), _c('el-col', {
    staticClass: "userinfo",
    attrs: {
      "span": 12
    }
  }, [_c('span', {
    staticStyle: {
      "float": "left"
    }
  }, [_c('el-button', {
    staticStyle: {
      "padding": "7px 10px"
    },
    attrs: {
      "type": "primary",
      "size": "mini",
      "round": "",
      "icon": "el-icon-bell"
    },
    on: {
      "click": _vm.menuShowChange
    }
  }, [_vm._v("折叠/展开")])], 1), _vm._v(" "), _c('span', {
    staticClass: "el-dropdown-link userinfo-inner"
  }, [_c('el-tag', {
    staticStyle: {
      "border": "none"
    },
    attrs: {
      "type": "text",
      "disabled": "true",
      "round": ""
    }
  }, [_vm._v("hi," + _vm._s(_vm.sysUserName) + "!")])], 1), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "round": "",
      "size": "mini"
    },
    on: {
      "click": function($event) {
        return _vm.updatePasswordDialog()
      }
    }
  }, [_vm._v("修改密码")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "icon": "el-icon-switch-button",
      "round": "",
      "size": "mini"
    },
    on: {
      "click": function($event) {
        return _vm.logOUt()
      }
    }
  }, [_vm._v("退出")])], 1)], 1), _vm._v(" "), _c('el-col', {
    staticClass: "main",
    attrs: {
      "span": 24
    }
  }, [_c('el-aside', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.menuShow),
      expression: "menuShow"
    }],
    style: ('width:' + _vm.leftNovWidth)
  }, [_c('el-menu', {
    staticClass: "el-menu-vertical-demo",
    attrs: {
      "id": "menuClass",
      "router": "",
      "unique-opened": "",
      "default-active": _vm.$route.path,
      "collapse": _vm.collapsed,
      "collapse-transition": true
    }
  }, [_vm._l((_vm.menuList), function(navMenu) {
    return [(navMenu.children && navMenu.children.length > 0) ? _c('el-submenu', {
      key: navMenu.menuId,
      attrs: {
        "index": navMenu.menuUrl
      }
    }, [_c('template', {
      slot: "title"
    }, [_c('i', {
      class: navMenu.menuIcon,
      staticStyle: {
        "color": "#428bca"
      }
    }), _vm._v(" "), _c('span', {
      attrs: {
        "slot": "title"
      },
      slot: "title"
    }, [_vm._v(_vm._s(navMenu.menuName))])]), _vm._v(" "), _vm._l((navMenu.children), function(navMenuSub) {
      return [(navMenuSub.children && navMenuSub.children.length > 0) ? _c('el-submenu', {
        key: navMenuSub.menuId,
        attrs: {
          "index": navMenuSub.menuUrl
        }
      }, [_c('template', {
        slot: "title"
      }, [_c('i', {
        class: navMenuSub.menuIcon,
        staticStyle: {
          "color": "#428bca"
        }
      }), _vm._v(" "), _c('span', {
        attrs: {
          "slot": "title"
        },
        slot: "title"
      }, [_vm._v(_vm._s(navMenuSub.menuName))])]), _vm._v(" "), _vm._l((navMenuSub.children), function(subBottom) {
        return _c('el-menu-item', {
          key: subBottom.menuId,
          attrs: {
            "data": subBottom,
            "index": subBottom.menuUrl,
            "route": subBottom.menuUrl
          },
          on: {
            "click": function($event) {
              return _vm.addTab(subBottom.menuName, subBottom.menuUrl)
            }
          }
        }, [_c('span', {
          attrs: {
            "slot": "title"
          },
          slot: "title"
        }, [_vm._v(_vm._s(subBottom.menuName))])])
      })], 2) : (navMenuSub.menuName === '人事通知') ? _c('el-menu-item', {
        key: navMenuSub.menuId,
        ref: "RSTZ",
        refInFor: true,
        attrs: {
          "id": "RSTZ",
          "data": navMenuSub.menuName,
          "index": navMenuSub.menuUrl,
          "route": navMenuSub.menuUrl
        }
      }, [_c('i', {
        class: navMenuSub.menuIcon,
        staticStyle: {
          "color": "#428bca"
        }
      }), _vm._v(" "), _c('span', {
        attrs: {
          "slot": "title"
        },
        slot: "title"
      }, [_vm._v(_vm._s(navMenuSub.menuName))])]) : _c('el-menu-item', {
        key: navMenuSub.menuId,
        attrs: {
          "data": navMenuSub,
          "index": navMenuSub.menuUrl,
          "route": navMenuSub.menuUrl
        },
        on: {
          "click": function($event) {
            return _vm.addTab(navMenuSub.menuName, navMenuSub.menuUrl)
          }
        }
      }, [_c('i', {
        class: navMenuSub.menuIcon,
        staticStyle: {
          "color": "#428bca"
        }
      }), _vm._v(" "), _c('span', {
        attrs: {
          "slot": "title"
        },
        slot: "title"
      }, [_vm._v(_vm._s(navMenuSub.menuName))])])]
    })], 2) : _c('el-menu-item', {
      key: navMenu.menuId,
      attrs: {
        "data": navMenu,
        "index": navMenu.menuUrl,
        "route": navMenu.menuUrl
      }
    }, [_c('i', {
      class: navMenu.menuIcon,
      staticStyle: {
        "color": "#428bca"
      }
    }), _vm._v(" "), _c('span', {
      attrs: {
        "slot": "title"
      },
      slot: "title"
    }, [_vm._v(_vm._s(navMenu.menuName))])])]
  })], 2)], 1), _vm._v(" "), _c('section', {
    staticClass: "content-container",
    staticStyle: {
      "padding": "0 10px",
      "box-sizing": "border-box"
    },
    style: ({
      width: _vm.sessionWidth
    })
  }, [_c('el-tabs', {
    style: ({
      width: _vm.sessionWidth
    }),
    attrs: {
      "type": "card",
      "closable": ""
    },
    on: {
      "tab-remove": _vm.removeTab,
      "tab-click": function($event) {
        return _vm.addNewtap(_vm.menuTabsValue)
      }
    },
    model: {
      value: (_vm.menuTabsValue),
      callback: function($$v) {
        _vm.menuTabsValue = $$v
      },
      expression: "menuTabsValue"
    }
  }, [_vm._l((_vm.menuTabs), function(item) {
    return _c('el-tab-pane', {
      key: item.name,
      attrs: {
        "label": item.title,
        "name": item.name
      }
    })
  }), _vm._v(" "), _c('el-tab-pane', {
    key: "全部关闭",
    attrs: {
      "label": "全部关闭",
      "name": "全部关闭"
    }
  })], 2), _vm._v(" "), _c('el-col', {
    staticClass: "content-wrapper",
    attrs: {
      "span": 24
    }
  }, [_c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [_c('keep-alive', {
    attrs: {
      "include": _vm.keepArrary
    }
  }, [_c('router-view', {
    key: _vm.key
  })], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('update-user-password', {
    attrs: {
      "visible": _vm.updatePassword.visible,
      "user-code": _vm.updatePassword.sysUserCode
    },
    on: {
      "close": _vm.closeDialog
    }
  })], 1)
},staticRenderFns: []}

/***/ }),

/***/ 385:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-container', {
    staticClass: "loginPage",
    style: ({
      height: _vm.tableHeight,
      width: _vm.tableWidth
    })
  }, [_c('el-main', [_c('div', {
    staticClass: "login-container"
  }, [_c('div', {
    staticClass: "loginLeft"
  }, [_c('div', {
    staticClass: "login_img"
  }, [_c('transition-group', {
    attrs: {
      "name": "flip-list",
      "tag": "ul"
    }
  }, _vm._l((_vm.currImgs), function(curImg) {
    return _c('li', {
      key: curImg,
      staticClass: "list-item"
    }, [_c('img', {
      attrs: {
        "src": curImg,
        "alt": "",
        "srcset": ""
      }
    })])
  }), 0)], 1)]), _vm._v(" "), _c('el-form', {
    ref: "loginForm",
    staticClass: "demo-ruleForm",
    attrs: {
      "model": _vm.loginData,
      "label-position": "left",
      "label-width": "0px",
      "rules": _vm.loginRules
    }
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("账号登录")]), _vm._v(" "), _c('img', {
    staticClass: "logoImg",
    attrs: {
      "src": _vm.logonImg,
      "alt": ""
    }
  }), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "username"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "auto-complete": "off",
      "placeholder": "请输入账号"
    },
    model: {
      value: (_vm.loginData.username),
      callback: function($$v) {
        _vm.$set(_vm.loginData, "username", $$v)
      },
      expression: "loginData.username"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-top": "10%"
    },
    attrs: {
      "prop": "password"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password",
      "auto-complete": "off",
      "placeholder": "请输入密码"
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.startLogin('loginForm')
      }
    },
    model: {
      value: (_vm.loginData.password),
      callback: function($$v) {
        _vm.$set(_vm.loginData, "password", $$v)
      },
      expression: "loginData.password"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "39px"
    }
  }), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "width": "100%",
      "text-align": "center"
    }
  }, [_c('el-button', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.startLogin('loginForm')
      }
    }
  }, [_vm._v("登录")])], 1)], 1)], 1)]), _vm._v(" "), _c('el-footer', [_c('el-row', {
    attrs: {
      "type": "flex",
      "justify": "center",
      "align": "middle"
    }
  }, [_c('a', {
    staticStyle: {
      "color": "#FFFFFF"
    },
    attrs: {
      "href": "https:/beian.miit.gov.cn/",
      "target": "blank"
    }
  }, [_vm._v("沪ICP备17009955号-1")])])], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 386:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "childSubfunc"
  }, _vm._l((_vm.navMenus), function(navMenu) {
    return _c('label', {
      key: navMenu.menuId
    }, [(navMenu.children && navMenu.children.length > 0) ? _c('el-submenu', {
      key: navMenu.menuId,
      attrs: {
        "index": navMenu.menuUrl
      }
    }, [_c('template', {
      slot: "title"
    }, [_c('i', {
      class: navMenu.menuIcon,
      staticStyle: {
        "color": "#428BCA"
      }
    }), _vm._v(" "), _c('span', {
      attrs: {
        "slot": "title"
      },
      slot: "title"
    }, [_vm._v(_vm._s(navMenu.menuName))])]), _vm._v(" "), _c('el-menu-item-group', {
      staticClass: "childSubfuncGroup"
    }, [_c('NavMenu', {
      attrs: {
        "navMenus": navMenu.children
      }
    })], 1)], 2) : _c('el-menu-item', {
      key: navMenu.menuId,
      attrs: {
        "data": navMenu,
        "index": navMenu.menuUrl,
        "route": navMenu.routeurl
      }
    }, [_c('span', {
      attrs: {
        "slot": "title"
      },
      slot: "title"
    }, [_vm._v(_vm._s(navMenu.funcname))])])], 1)
  }), 0)
},staticRenderFns: []}

/***/ }),

/***/ 387:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "page-container"
  }, [_vm._v("404 page not found")])
},staticRenderFns: []}

/***/ }),

/***/ 388:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    style: ({
      height: _vm.tableHeight,
      width: _vm.tableWidth
    }),
    attrs: {
      "id": "app"
    }
  }, [_c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [_c('router-view')], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "正在下载，请等待",
      "visible": _vm.progressShow,
      "close-on-click-modal": false,
      "close-on-press-excape": false,
      "width": "20%"
    }
  }, [_c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [(_vm.percentage === 0) ? _c('el-row', [_vm._v("文件生成中...")]) : _c('el-progress', {
    attrs: {
      "percentage": _vm.percentage,
      "type": "circle"
    }
  })], 1)])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 389:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-form', {
    ref: "ruleForm2",
    staticClass: "demo-ruleForm login-container",
    attrs: {
      "model": _vm.ruleForm2,
      "width": "550px",
      "rules": _vm.rules2,
      "label-position": "left",
      "label-width": "0px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "oldpass",
      "label-width": "100px",
      "label": "原密码"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "auto-complete": "off",
      "placeholder": "原密码",
      "show-password": ""
    },
    model: {
      value: (_vm.ruleForm2.oldpass),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm2, "oldpass", $$v)
      },
      expression: "ruleForm2.oldpass"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "prop": "newpass",
      "label-width": "100px",
      "label": "新密码"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password",
      "auto-complete": "off",
      "placeholder": "新密码",
      "show-password": ""
    },
    model: {
      value: (_vm.ruleForm2.newpass),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm2, "newpass", $$v)
      },
      expression: "ruleForm2.newpass"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "newlpass",
      "label-width": "100px",
      "label": "新密码确认"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password",
      "auto-complete": "off",
      "placeholder": "新密码确认",
      "show-password": ""
    },
    model: {
      value: (_vm.ruleForm2.newlpass),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm2, "newlpass", $$v)
      },
      expression: "ruleForm2.newlpass"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('el-button', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "primary"
    },
    nativeOn: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.handleSubmit()
      }
    }
  }, [_vm._v("确认修改")])], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 390:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "page-container"
  }, [_vm._v("正在努力加载中...")])
},staticRenderFns: []}

/***/ }),

/***/ 81:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var showAsThousandFilter = exports.showAsThousandFilter = function showAsThousandFilter(val) {
    if (val === null || val === "0") {
        return "0";
    }

    if (val > 1000 || val < -1000) {
        return val.replace(/(\d{1,3})(?=(\d{3})+(?:$|\.))/g, "$1,");
    } else {
        return val;
    }
};

var FormatNumbers = exports.FormatNumbers = function FormatNumbers(num) {
    if (num !== undefined && num !== null) {
        num = num.toString().replace(/[$,]/g, '');
        if (isNaN(num)) num = "0";
        var sign = Number(num) === (num = Math.abs(num));
        num = Math.floor(num * 100 + 0.50000000001);
        var cents = num % 100;
        num = Math.floor(num / 100).toString();
        if (cents < 10) cents = "0" + cents;
        for (var i = 0; i < Math.floor((num.length - (1 + i)) / 3); i++) {
            num = num.substring(0, num.length - (4 * i + 3)) + ',' + num.substring(num.length - (4 * i + 3));
        }return (sign ? '' : '-') + num + '.' + cents;
    }

    return "";
};

/***/ }),

/***/ 87:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof2 = __webpack_require__(25);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.formatMoney = function (val) {
	if (val) {
		val = val.toString().replace(/\$|\,/g, '');
		if (isNaN(val)) {
			val = "0";
		}
		var sign = val == (val = Math.abs(val));
		val = Math.floor(val * 100 + 0.50000000001);
		var cents = val % 100;
		val = Math.floor(val / 100).toString();
		if (cents < 10) {
			cents = "0" + cents;
		}
		for (var i = 0; i < Math.floor((val.length - (1 + i)) / 3); i++) {
			val = val.substring(0, val.length - (4 * i + 3)) + ',' + val.substring(val.length - (4 * i + 3));
		}
		return (sign ? '' : '-') + val + '.' + cents;
	}
	return '0.00';
};

exports.NumFormat = function (value) {
	if (!value || value == undefined || value.length <= 0) {
		return '0';
	}
	return value;
};

exports.NumTwoPoint = function (value) {
	if (value == undefined || value == 0) {
		return '0';
	}
	return Number(value).toFixed(2);
};

exports.NumPoint = function (value, lenght) {
	if (value == undefined || value == 0) {
		return Number(0).toFixed(lenght);
	}
	return Number(value).toFixed(lenght);
};

exports.NumRatio = function (value) {
	if (value == undefined || value == 0) {
		return '0.00%';
	}
	return Number(value).toFixed(2) + '%';
};

exports.DateFormate = function (value, fmt) {
	var date;
	if (!value) {
		return "";
	}
	if (typeof value === 'string') {
		date = new Date(value.replace(/-/g, '/').replace(/T|Z/g, ' ').trim());
	} else if ((typeof value === "undefined" ? "undefined" : (0, _typeof3.default)(value)) === 'object') {
		date = new Date(value);
	}

	if (/(y+)/.test(fmt)) {
		fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length));
	}
	var o = {
		'M+': date.getMonth() + 1,
		'd+': date.getDate(),
		'h+': date.getHours(),
		'm+': date.getMinutes(),
		's+': date.getSeconds()
	};
	for (var k in o) {
		if (new RegExp("(" + k + ")").test(fmt)) {
			var str = o[k] + '';
			fmt = fmt.replace(RegExp.$1, RegExp.$1.length === 1 ? str : ('00' + str).substr(str.length));
		}
	}
	return fmt;
};

exports.DateStrFormate = function (value, fmt) {
	if (!value) return "";
	var getDate = new Date(value);
	var o = {
		'M+': getDate.getMonth() + 1,
		'd+': getDate.getDate(),
		'h+': getDate.getHours(),
		'm+': getDate.getMinutes(),
		's+': getDate.getSeconds(),
		'q+': Math.floor((getDate.getMonth() + 3) / 3),
		'S': getDate.getMilliseconds()
	};
	if (/(y+)/.test(fmt)) {
		fmt = fmt.replace(RegExp.$1, (getDate.getFullYear() + '').substr(4 - RegExp.$1.length));
	}
	for (var k in o) {
		if (new RegExp('(' + k + ')').test(fmt)) {
			fmt = fmt.replace(RegExp.$1, RegExp.$1.length === 1 ? o[k] : ('00' + o[k]).substr(('' + o[k]).length));
		}
	}
	return fmt;
};

exports.ValueBind = function (value, DataArray, fromkey, resKey) {
	if (DataArray && DataArray.length > 0) {
		for (var index = 0; index < DataArray.length; index++) {
			var item = DataArray[index];
			var iv = eval("item." + fromkey);
			if (iv == value) {
				return eval("item." + resKey);
			}
		}
	}
	return value;
};

/***/ })

},[203]);


// WEBPACK FOOTER //
// static/js/app.86a6bd6d41d4d47124ae.1787063964206.js